const EyeoffSvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.2049 9.85034C20.3168 11.0087 20.9869 11.9809 20.9998 11.9998C20.9998 11.9998 16.9089 17.9998 11.9998 17.9998C11.6892 17.9998 11.3879 17.9855 11.0955 17.9597L19.2049 9.85034Z"
        fill="#979797"
      />
      <path
        d="M12 6C12.866 6 13.7058 6.18854 14.5029 6.49609L12 9C10.3431 9 9 10.3431 9 12L5.52734 15.4717C3.75112 13.8319 3 12 3 12C3 12 5.45455 6 12 6Z"
        fill="#979797"
      />
      <rect
        opacity="0.3"
        x="5.09998"
        y="18.4351"
        width={19}
        height={2}
        transform="rotate(-45 5.09998 18.4351)"
        fill="#979797"
      />
    </svg>
  );
};

// svgFile.js — Add License/ID Card SVG
export const IdCardSvg = ({ width = 20, height = 20, color = "currentColor" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="M8 8h8" />
    <path d="M8 12h6" />
    <path d="M8 16h4" />
    <circle cx="17" cy="12" r="2" />
    <circle cx="17" cy="16" r="2" />
  </svg>
);

// Or use this simpler one
export const LicenseSvg = ({ width = 20, height = 20, color = "currentColor" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
    <line x1="3" y1="9" x2="21" y2="9" />
    <line x1="9" y1="21" x2="9" y2="9" />
    <circle cx="15" cy="12" r="2" />
    <circle cx="15" cy="16" r="2" />
  </svg>
);

export const BuildingWhiteSvg = ({ width = 20, height = 20, color = "currentColor" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
    <line x1="9" y1="22" x2="9" y2="18" />
    <line x1="15" y1="22" x2="15" y2="18" />
    <line x1="8" y1="6" x2="16" y2="6" />
    <line x1="8" y1="10" x2="16" y2="10" />
    <line x1="8" y1="14" x2="12" y2="14" />
  </svg>
);

const EyeSvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 12C1 12 5 5 12 5C19 5 23 12 23 12C23 12 19 19 12 19C5 19 1 12 1 12Z"
        stroke="#979797"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="12"
        cy="12"
        r="3"
        stroke="#979797"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
const CancelSvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.71 8.29008C15.617 8.19635 15.5064 8.12196 15.3845 8.07119C15.2627 8.02042 15.132 7.99428 15 7.99428C14.8679 7.99428 14.7372 8.02042 14.6154 8.07119C14.4935 8.12196 14.3829 8.19635 14.29 8.29008L12 10.5901L9.70996 8.29008C9.52165 8.10178 9.26626 7.99599 8.99996 7.99599C8.73366 7.99599 8.47826 8.10178 8.28996 8.29008C8.10165 8.47838 7.99587 8.73378 7.99587 9.00008C7.99587 9.26638 8.10165 9.52178 8.28996 9.71008L10.59 12.0001L8.28996 14.2901C8.19623 14.383 8.12183 14.4936 8.07107 14.6155C8.0203 14.7374 7.99416 14.8681 7.99416 15.0001C7.99416 15.1321 8.0203 15.2628 8.07107 15.3847C8.12183 15.5065 8.19623 15.6171 8.28996 15.7101C8.38292 15.8038 8.49352 15.8782 8.61538 15.929C8.73724 15.9797 8.86795 16.0059 8.99996 16.0059C9.13197 16.0059 9.26267 15.9797 9.38453 15.929C9.50639 15.8782 9.61699 15.8038 9.70996 15.7101L12 13.4101L14.29 15.7101C14.3829 15.8038 14.4935 15.8782 14.6154 15.929C14.7372 15.9797 14.8679 16.0059 15 16.0059C15.132 16.0059 15.2627 15.9797 15.3845 15.929C15.5064 15.8782 15.617 15.8038 15.71 15.7101C15.8037 15.6171 15.8781 15.5065 15.9288 15.3847C15.9796 15.2628 16.0058 15.1321 16.0058 15.0001C16.0058 14.8681 15.9796 14.7374 15.9288 14.6155C15.8781 14.4936 15.8037 14.383 15.71 14.2901L13.41 12.0001L15.71 9.71008C15.8037 9.61712 15.8781 9.50652 15.9288 9.38466C15.9796 9.2628 16.0058 9.13209 16.0058 9.00008C16.0058 8.86807 15.9796 8.73736 15.9288 8.6155C15.8781 8.49364 15.8037 8.38304 15.71 8.29008ZM19.07 4.93008C18.1475 3.97498 17.044 3.21316 15.824 2.68907C14.604 2.16498 13.2918 1.88911 11.964 1.87757C10.6362 1.86604 9.31938 2.11905 8.09042 2.62186C6.86145 3.12467 5.74493 3.8672 4.80601 4.80613C3.86708 5.74506 3.12455 6.86158 2.62174 8.09054C2.11893 9.3195 1.86591 10.6363 1.87745 11.9641C1.88899 13.2919 2.16485 14.6041 2.68894 15.8241C3.21303 17.0442 3.97486 18.1476 4.92996 19.0701C5.85243 20.0252 6.95587 20.787 8.17591 21.3111C9.39595 21.8352 10.7082 22.111 12.0359 22.1226C13.3637 22.1341 14.6805 21.8811 15.9095 21.3783C17.1385 20.8755 18.255 20.133 19.1939 19.194C20.1328 18.2551 20.8754 17.1386 21.3782 15.9096C21.881 14.6807 22.134 13.3639 22.1225 12.0361C22.1109 10.7083 21.8351 9.39607 21.311 8.17603C20.7869 6.95599 20.0251 5.85255 19.07 4.93008ZM17.66 17.6601C16.352 18.9695 14.6305 19.7849 12.7888 19.9674C10.947 20.1499 9.09896 19.6881 7.55948 18.6609C6.02 17.6336 4.88432 16.1043 4.34593 14.3336C3.80754 12.5628 3.89976 10.6602 4.60687 8.94986C5.31398 7.23951 6.59223 5.82723 8.22385 4.95364C9.85546 4.08006 11.7395 3.79921 13.555 4.15895C15.3704 4.5187 17.005 5.49677 18.1802 6.92654C19.3554 8.35631 19.9985 10.1493 20 12.0001C20.0035 13.0514 19.7985 14.0929 19.3969 15.0645C18.9952 16.036 18.4049 16.9182 17.66 17.6601Z"
        fill="black"
      />
    </svg>

  );
};
const NotificationSvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_163_2280"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={3}
        y={1}
        width={19}
        height={18}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.00012 1H21.497V18.348H3.00012V1Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_163_2280)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.2471 2.5C8.75214 2.5 6.31614 5.238 6.31614 7.695C6.31614 9.774 5.73914 10.735 5.22914 11.583C4.82014 12.264 4.49714 12.802 4.49714 13.971C4.66414 15.857 5.90914 16.848 12.2471 16.848C18.5501 16.848 19.8341 15.813 20.0001 13.906C19.9971 12.802 19.6741 12.264 19.2651 11.583C18.7551 10.735 18.1781 9.774 18.1781 7.695C18.1781 5.238 15.7421 2.5 12.2471 2.5ZM12.2471 18.348C7.57114 18.348 3.34514 18.018 3.00014 14.035C2.99714 12.387 3.50014 11.549 3.94414 10.811C4.39314 10.063 4.81614 9.358 4.81614 7.695C4.81614 4.462 7.80213 1 12.2471 1C16.6921 1 19.6781 4.462 19.6781 7.695C19.6781 9.358 20.1011 10.063 20.5501 10.811C20.9941 11.549 21.4971 12.387 21.4971 13.971C21.1481 18.018 16.9231 18.348 12.2471 18.348Z"
          fill="black"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1984 22.5001H12.1964C11.0754 22.4991 10.0144 22.0051 9.20939 21.1081C8.93239 20.8011 8.95739 20.3261 9.26539 20.0501C9.57339 19.7721 10.0474 19.7971 10.3244 20.1061C10.8424 20.6831 11.5074 21.0001 12.1974 21.0001H12.1984C12.8914 21.0001 13.5594 20.6831 14.0784 20.1051C14.3564 19.7981 14.8304 19.7731 15.1374 20.0501C15.4454 20.3271 15.4704 20.8021 15.1934 21.1091C14.3854 22.0061 13.3224 22.5001 12.1984 22.5001Z"
        fill="black"
      />
    </svg>


  );
};
const EditSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.57699 2.32422H6.46116C3.89866 2.32422 2.29199 4.13839 2.29199 6.70672V13.6351C2.29199 16.2034 3.89116 18.0176 6.46116 18.0176H13.8145C16.3853 18.0176 17.9845 16.2034 17.9845 13.6351V10.2784"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.35652 9.10074L13.584 2.87324C14.3599 2.09824 15.6174 2.09824 16.3932 2.87324L17.4074 3.88741C18.1832 4.66324 18.1832 5.92158 17.4074 6.69658L11.1499 12.9541C10.8107 13.2932 10.3507 13.4841 9.87069 13.4841H6.74902L6.82736 10.3341C6.83902 9.87074 7.02819 9.42908 7.35652 9.10074Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6377 3.83545L16.4427 7.64045"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>



  );
};
const JobSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99561 14.5219C9.65061 14.5219 9.37061 14.2419 9.37061 13.8969V11.7827C9.37061 11.4377 9.65061 11.1577 9.99561 11.1577C10.3406 11.1577 10.6206 11.4377 10.6206 11.7827V13.8969C10.6206 14.2419 10.3406 14.5219 9.99561 14.5219Z"
        fill="white"
      />
      <mask
        id="mask0_177_2933"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={1}
        y={3}
        width={18}
        height={10}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.6665 3.81641H18.3247V12.4089H1.6665V3.81641Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_177_2933)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.9165 9.49391C4.8965 10.5697 7.39317 11.1589 9.9915 11.1589C12.5948 11.1589 15.094 10.5697 17.0748 9.49391V6.99224C17.0748 5.92974 16.2157 5.06641 15.1582 5.06641H4.8415C3.77984 5.06641 2.9165 5.92641 2.9165 6.98391V9.49391ZM9.9915 12.4089C7.03734 12.4089 4.18984 11.6939 1.97567 10.3972C1.784 10.2856 1.6665 10.0806 1.6665 9.85807V6.98391C1.6665 5.23724 3.09067 3.81641 4.8415 3.81641H15.1582C16.9048 3.81641 18.3248 5.24057 18.3248 6.99224V9.85807C18.3248 10.0806 18.2065 10.2856 18.0157 10.3972C15.8015 11.6939 12.9515 12.4089 9.9915 12.4089Z"
          fill="white"
        />
      </g>
      <mask
        id="mask1_177_2933"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={6}
        y={1}
        width={8}
        height={5}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.4541 1.6665H13.5374V5.06309H6.4541V1.6665Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_177_2933)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.9124 5.06317C12.5674 5.06317 12.2874 4.78317 12.2874 4.43817V4.13317C12.2874 3.46234 11.7416 2.9165 11.0708 2.9165H8.92077C8.24993 2.9165 7.7041 3.46234 7.7041 4.13317V4.43817C7.7041 4.78317 7.4241 5.06317 7.0791 5.06317C6.7341 5.06317 6.4541 4.78317 6.4541 4.43817V4.13317C6.4541 2.77317 7.56077 1.6665 8.92077 1.6665H11.0708C12.4308 1.6665 13.5374 2.77317 13.5374 4.13317V4.43817C13.5374 4.78317 13.2574 5.06317 12.9124 5.06317Z"
          fill="white"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8286 18.1168H5.16198C3.43282 18.1168 1.97698 16.766 1.84615 15.041L1.68782 12.9502C1.66198 12.606 1.92032 12.3052 2.26448 12.2793C2.61032 12.2668 2.90865 12.511 2.93532 12.856L3.09282 14.946C3.17448 16.0227 4.08282 16.8668 5.16198 16.8668H14.8286C15.9078 16.8668 16.817 16.0227 16.8978 14.946L17.0561 12.856C17.0828 12.511 17.3886 12.266 17.727 12.2793C18.0711 12.3052 18.3286 12.606 18.3028 12.9502L18.1445 15.041C18.0136 16.766 16.5578 18.1168 14.8286 18.1168Z"
        fill="white"
      />
    </svg>
  );
};
const LocationSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2088 7.0835C9.40466 7.0835 8.75049 7.73766 8.75049 8.54266C8.75049 9.34683 9.40466 10.0002 10.2088 10.0002C11.013 10.0002 11.6672 9.34683 11.6672 8.54266C11.6672 7.73766 11.013 7.0835 10.2088 7.0835ZM10.2088 11.2502C8.71549 11.2502 7.50049 10.036 7.50049 8.54266C7.50049 7.0485 8.71549 5.8335 10.2088 5.8335C11.7022 5.8335 12.9172 7.0485 12.9172 8.54266C12.9172 10.036 11.7022 11.2502 10.2088 11.2502Z"
        fill="white"
        fillOpacity="0.7"
      />
      <mask
        id="mask0_177_2944"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={3}
        y={1}
        width={15}
        height={17}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.3335 1.6665H17.0831V17.9165H3.3335V1.6665Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_177_2944)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.208 2.9165C7.10634 2.9165 4.58301 5.464 4.58301 8.594C4.58301 12.5765 9.26967 16.4565 10.208 16.6632C11.1463 16.4557 15.833 12.5757 15.833 8.594C15.833 5.464 13.3097 2.9165 10.208 2.9165ZM10.208 17.9165C8.71301 17.9165 3.33301 13.2898 3.33301 8.594C3.33301 4.774 6.41717 1.6665 10.208 1.6665C13.9988 1.6665 17.083 4.774 17.083 8.594C17.083 13.2898 11.703 17.9165 10.208 17.9165Z"
          fill="white"
          fillOpacity="0.7"
        />
      </g>
    </svg>

  );
};
const PhoneSvg = () => {
  return (
    <svg
      width={17}
      height={17}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_103_6494"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={10}
        y={1}
        width={7}
        height={7}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1675 1.41699H16.2159V7.46107H10.1675V1.41699Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_103_6494)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.6845 7.46107C15.4174 7.46107 15.1879 7.26061 15.1575 6.98932C14.889 4.59799 13.0318 2.74215 10.6397 2.47653C10.3486 2.44394 10.1382 2.18186 10.1708 1.89003C10.2027 1.5989 10.4626 1.38428 10.7573 1.42111C13.6459 1.74199 15.8892 3.98244 16.2129 6.87032C16.2455 7.16215 16.0358 7.42494 15.7447 7.45753C15.7248 7.45965 15.7043 7.46107 15.6845 7.46107Z"
          fill="#51627B"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1767 7.46857C12.9273 7.46857 12.7056 7.2929 12.656 7.03932C12.452 5.99099 11.6438 5.18278 10.5969 4.97949C10.3086 4.92353 10.1209 4.64515 10.1769 4.35686C10.2328 4.06857 10.5162 3.88015 10.7995 3.93682C12.2735 4.22299 13.4118 5.36057 13.6987 6.83532C13.7547 7.12432 13.5669 7.4027 13.2794 7.45865C13.2447 7.46503 13.2107 7.46857 13.1767 7.46857Z"
        fill="#51627B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.38013 2.84195C3.74527 1.4767 4.63473 1.11502 5.58325 1.66031C5.85613 1.81723 6.11235 2.03748 6.46021 2.39078L7.52661 3.49723C8.11595 4.14031 8.25074 4.75725 8.05884 5.47965L8.0315 5.57438L8.0022 5.67008L7.85962 6.08805C7.55432 7.02657 7.68258 7.55679 8.7688 8.64274C9.898 9.77155 10.4252 9.86398 11.4358 9.5109L11.6165 9.4484L11.8342 9.37711L11.9299 9.35074C12.6976 9.14605 13.3466 9.30991 14.0344 9.99723L14.8938 10.8273L15.1467 11.0763C15.4273 11.3625 15.6123 11.5896 15.7493 11.8293C16.2913 12.7776 15.9292 13.6662 14.5247 15.0656L14.3909 15.2004C14.1812 15.4024 13.9853 15.5471 13.6975 15.6838C13.2144 15.9131 12.6439 15.9996 11.9807 15.9074C10.3463 15.6801 8.27334 14.3907 5.64673 11.7648C5.43291 11.551 5.22746 11.3415 5.0315 11.1359L4.65161 10.7296C1.08907 6.859 0.774724 4.48169 2.23462 2.99039L2.32935 2.89567L2.38013 2.84195ZM5.05396 2.58121C4.72708 2.39327 4.37405 2.47323 3.72095 3.03531L3.51587 3.21891C3.4801 3.25193 3.44296 3.28588 3.40552 3.32145L3.17017 3.55094L3.14868 3.57731L2.9895 3.73746C2.60396 4.13127 2.42106 4.61212 2.57837 5.43863C2.83663 6.79511 4.01913 8.63586 6.39771 11.0138C8.87594 13.4914 10.7647 14.6661 12.1272 14.8556C12.9213 14.966 13.3264 14.773 13.7395 14.3498L14.0549 14.0324C14.2026 13.8779 14.3283 13.7375 14.4348 13.6095L14.5803 13.4259C14.9518 12.9312 14.9861 12.6345 14.8274 12.3566C14.7669 12.2508 14.6791 12.1341 14.551 11.9923L14.3772 11.8088L14.2747 11.7062L13.1897 10.6593C12.8273 10.3251 12.5794 10.2768 12.2034 10.3771L12.095 10.4084L11.6458 10.5617C10.3423 10.9826 9.40154 10.7781 8.01685 9.39371C6.58293 7.96007 6.41526 7.00267 6.89575 5.62418L6.92603 5.53531L7.01099 5.27848L7.05298 5.11539C7.12729 4.75912 7.04241 4.51015 6.65943 4.12711C6.64379 4.11148 6.62663 4.09361 6.60767 4.07438L5.59986 3.03238C5.36922 2.80503 5.20169 2.66616 5.05396 2.58121Z"
        fill="#51627B"
      />
    </svg>



  );
};
const EmailSvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7769 13.465C11.1079 13.465 10.4409 13.244 9.88289 12.802L5.39789 9.18599C5.07489 8.92599 5.02489 8.45299 5.28389 8.13099C5.54489 7.80999 6.01689 7.75899 6.33889 8.01799L10.8199 11.63C11.3829 12.076 12.1759 12.076 12.7429 11.626L17.1789 8.01999C17.5009 7.75699 17.9729 7.80699 18.2349 8.12899C18.4959 8.44999 18.4469 8.92199 18.1259 9.18399L13.6819 12.796C13.1199 13.242 12.4479 13.465 11.7769 13.465Z"
        fill="white"
      />
      <mask
        id="mask0_297_3090"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={1}
        y={2}
        width={22}
        height={20}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 2H22.4999V21.5H1V2Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_297_3090)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.83891 20H16.6589C16.6609 19.998 16.6689 20 16.6749 20C17.8159 20 18.8279 19.592 19.6039 18.817C20.5049 17.92 20.9999 16.631 20.9999 15.188V8.32C20.9999 5.527 19.1739 3.5 16.6589 3.5H6.84091C4.32591 3.5 2.49991 5.527 2.49991 8.32V15.188C2.49991 16.631 2.99591 17.92 3.89591 18.817C4.67191 19.592 5.68491 20 6.82491 20H6.83891ZM6.82191 21.5C5.27891 21.5 3.90091 20.94 2.83691 19.88C1.65191 18.698 0.999908 17.032 0.999908 15.188V8.32C0.999908 4.717 3.51091 2 6.84091 2H16.6589C19.9889 2 22.4999 4.717 22.4999 8.32V15.188C22.4999 17.032 21.8479 18.698 20.6629 19.88C19.5999 20.939 18.2209 21.5 16.6749 21.5H16.6589H6.84091H6.82191Z"
          fill="white"
        />
      </g>
    </svg>


  );
};
const NoteSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_177_2959"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={2}
        y={1}
        width={15}
        height={18}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.50049 1.67627H16.7111V18.2209H2.50049V1.67627Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_177_2959)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.31141 2.92627C4.93057 2.92627 3.78391 4.0446 3.75141 5.42377V14.3363C3.72057 15.7638 4.84557 16.9396 6.25891 16.9713H12.9789C14.3697 16.9138 15.4714 15.7579 15.4614 14.3413V6.9496L11.5989 2.92627H6.32141H6.31141ZM6.32141 18.2213H6.23057C4.12891 18.1738 2.45557 16.4254 2.50141 14.3229V5.40877C2.54974 3.34127 4.25724 1.67627 6.30974 1.67627H6.32391H11.8656C12.0356 1.67627 12.1981 1.74544 12.3164 1.86794L16.5372 6.26544C16.6489 6.38127 16.7114 6.5371 16.7114 6.69794V14.3363C16.7264 16.4271 15.0981 18.1354 13.0039 18.2204L6.32141 18.2213Z"
          fill="white"
          fillOpacity="0.7"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0823 7.48699H13.7865C12.2615 7.48283 11.0215 6.23949 11.0215 4.71616V2.29199C11.0215 1.94699 11.3015 1.66699 11.6465 1.66699C11.9915 1.66699 12.2715 1.94699 12.2715 2.29199V4.71616C12.2715 5.55282 12.9523 6.23449 13.7882 6.23699H16.0823C16.4273 6.23699 16.7073 6.51699 16.7073 6.86199C16.7073 7.20699 16.4273 7.48699 16.0823 7.48699Z"
        fill="white"
        fillOpacity="0.7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4907 13.4238H6.99072C6.64572 13.4238 6.36572 13.1438 6.36572 12.7988C6.36572 12.4538 6.64572 12.1738 6.99072 12.1738H11.4907C11.8357 12.1738 12.1157 12.4538 12.1157 12.7988C12.1157 13.1438 11.8357 13.4238 11.4907 13.4238Z"
        fill="white"
        fillOpacity="0.7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.7869 10.2974H6.99023C6.64523 10.2974 6.36523 10.0174 6.36523 9.67236C6.36523 9.32736 6.64523 9.04736 6.99023 9.04736H9.7869C10.1319 9.04736 10.4119 9.32736 10.4119 9.67236C10.4119 10.0174 10.1319 10.2974 9.7869 10.2974Z"
        fill="white"
        fillOpacity="0.7"
      />
    </svg>


  );
};
const CamraSvg = () => {
  return (
    <svg
      width={36}
      height={36}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0229 5.03125C14.8063 4.32215 21.1933 4.32215 22.9761 5.03125C23.9488 5.41842 24.6051 6.1515 25.2085 7.24707L25.8872 8.54785C25.9027 8.5735 25.9174 8.5958 25.9302 8.61523L25.9878 8.69434C26.2968 9.03084 26.8135 9.23429 27.1548 9.23438C30.3827 9.23438 33.0003 11.8511 33.0005 15.0781V23.7705C33.0005 27.8868 29.6617 31.2256 25.5454 31.2256H10.4556C6.33822 31.2256 3.00049 27.8873 3.00049 23.7705V15.0781C3.00063 11.8511 5.61825 9.23438 8.84619 9.23438C9.18625 9.23429 9.70367 9.03054 10.0132 8.69434C10.0194 8.6876 10.0278 8.67735 10.0376 8.66406L10.1147 8.5459L10.7915 7.24707C11.3944 6.15149 12.0499 5.41863 13.0229 5.03125ZM21.9653 7.0625C20.4214 6.62622 15.052 6.64609 13.855 7.12207C13.4755 7.27313 13.1367 7.65141 12.7622 8.33203L12.1851 9.44824L12.0435 9.70508C11.9248 9.90237 11.8059 10.0692 11.6704 10.2168C10.9108 11.0424 9.78698 11.4843 8.84619 11.4844L8.6001 11.4932C6.72945 11.6197 5.25063 13.1766 5.25049 15.0781V23.7705C5.25049 26.6447 7.58095 28.9756 10.4556 28.9756H25.5454C28.4191 28.9756 30.7505 26.6442 30.7505 23.7705V15.0781C30.7503 13.0939 29.1402 11.4844 27.1548 11.4844L26.894 11.4736C26.0113 11.401 25.0193 10.9673 24.3296 10.2158C24.196 10.0702 24.0783 9.90452 23.9604 9.70898C23.9436 9.68098 23.922 9.64418 23.8979 9.60059L23.7241 9.27344L23.2378 8.33203C22.8629 7.65143 22.5237 7.27319 22.144 7.12207L21.9653 7.0625Z"
        fill="#555555"
      />
      <path
        d="M26.2572 12.75C27.0856 12.75 27.7572 13.4216 27.7572 14.25C27.7572 15.0193 27.1781 15.6533 26.4321 15.7399L26.2572 15.75C25.4152 15.75 24.7437 15.0784 24.7437 14.25C24.7437 13.4807 25.3227 12.8467 26.0687 12.7601L26.2572 12.75Z"
        fill="#555555"
      />
      <path
        d="M18 13.7983C21.2553 13.7984 23.8936 16.4366 23.8936 19.6919C23.8935 22.9472 21.2553 25.5854 18 25.5854C14.7447 25.5854 12.1065 22.9472 12.1064 19.6919C12.1064 16.4366 14.7447 13.7983 18 13.7983ZM18 16.0483C15.9873 16.0483 14.3564 17.6792 14.3564 19.6919C14.3565 21.7045 15.9873 23.3354 18 23.3354C20.0126 23.3354 21.6435 21.7045 21.6436 19.6919C21.6436 17.6792 20.0127 16.0484 18 16.0483Z"
        fill="#555555"
      />
    </svg>



  );
};
const PlusSvg = () => {
  return (
    <svg
      width={13}
      height={13}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.75989 12.8159C5.59989 12.8159 5.46389 12.7599 5.35189 12.6479C5.23989 12.5359 5.18389 12.3999 5.18389 12.2399V7.55991H0.575891C0.415891 7.55991 0.279891 7.50391 0.167891 7.39191C0.0558907 7.27991 -0.000109315 7.14391 -0.000109315 6.98391V5.71191C-0.000109315 5.53591 0.0558907 5.39991 0.167891 5.30391C0.279891 5.19191 0.415891 5.13591 0.575891 5.13591H5.18389V0.575909C5.18389 0.415909 5.23989 0.27991 5.35189 0.16791C5.46389 0.0559096 5.59989 -9.05991e-05 5.75989 -9.05991e-05H7.15189C7.32789 -9.05991e-05 7.46389 0.0559096 7.55989 0.16791C7.67189 0.27991 7.72789 0.415909 7.72789 0.575909V5.13591H12.3359C12.4959 5.13591 12.6319 5.19191 12.7439 5.30391C12.8559 5.39991 12.9119 5.53591 12.9119 5.71191V6.98391C12.9119 7.14391 12.8559 7.27991 12.7439 7.39191C12.6319 7.50391 12.4959 7.55991 12.3359 7.55991H7.72789V12.2399C7.72789 12.3999 7.67189 12.5359 7.55989 12.6479C7.46389 12.7599 7.32789 12.8159 7.15189 12.8159H5.75989Z"
        fill="white"
      />
    </svg>

  );
};
const UploadSvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_177_4016"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={2}
        y={8}
        width={20}
        height={15}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.00049 8.79395H22.0001V22.5379H2.00049V8.79395Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_177_4016)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.5655 22.5379H6.43549C3.99049 22.5379 2.00049 20.5489 2.00049 18.1029V13.2279C2.00049 10.7829 3.99049 8.79395 6.43549 8.79395H7.36849C7.78249 8.79395 8.11849 9.12995 8.11849 9.54395C8.11849 9.95795 7.78249 10.2939 7.36849 10.2939H6.43549C4.81649 10.2939 3.50049 11.6099 3.50049 13.2279V18.1029C3.50049 19.7219 4.81649 21.0379 6.43549 21.0379H17.5655C19.1835 21.0379 20.5005 19.7219 20.5005 18.1029V13.2189C20.5005 11.6059 19.1885 10.2939 17.5765 10.2939H16.6335C16.2195 10.2939 15.8835 9.95795 15.8835 9.54395C15.8835 9.12995 16.2195 8.79395 16.6335 8.79395H17.5765C20.0155 8.79395 22.0005 10.7789 22.0005 13.2189V18.1029C22.0005 20.5489 20.0105 22.5379 17.5655 22.5379Z"
          fill="black"
        />
      </g>
      <mask
        id="mask1_177_4016"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={11}
        y={2}
        width={2}
        height={14}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.25 2H12.75V15.5409H11.25V2Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_177_4016)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 15.541C11.586 15.541 11.25 15.205 11.25 14.791V2.75C11.25 2.336 11.586 2 12 2C12.414 2 12.75 2.336 12.75 2.75V14.791C12.75 15.205 12.414 15.541 12 15.541Z"
          fill="black"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.0852 6.42853C8.8942 6.42853 8.7022 6.35553 8.5562 6.20953C8.2632 5.91753 8.2612 5.44353 8.5542 5.14953L11.4692 2.22153C11.7502 1.93853 12.2502 1.93853 12.5312 2.22153L15.4472 5.14953C15.7392 5.44353 15.7382 5.91753 15.4452 6.20953C15.1512 6.50153 14.6772 6.50153 14.3852 6.20753L12.0002 3.81353L9.6162 6.20753C9.4702 6.35553 9.2772 6.42853 9.0852 6.42853Z"
        fill="black"
      />
    </svg>


  );
};
const HeartSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_166_520)">
        <path
          d="M14.5833 0.76416C13.645 0.778756 12.7271 1.0407 11.9223 1.52355C11.1176 2.0064 10.4545 2.69305 10 3.51416C9.54554 2.69305 8.88245 2.0064 8.0777 1.52355C7.27296 1.0407 6.35505 0.778756 5.41667 0.76416C3.92079 0.829152 2.51143 1.48354 1.49649 2.58435C0.481556 3.68517 -0.0564528 5.14293 5.93206e-06 6.63916C5.93206e-06 12.285 9.13001 18.8058 9.51834 19.0825L10 19.4233L10.4817 19.0825C10.87 18.8075 20 12.285 20 6.63916C20.0565 5.14293 19.5185 3.68517 18.5035 2.58435C17.4886 1.48354 16.0792 0.829152 14.5833 0.76416ZM10 17.3717C7.28917 15.3467 1.66667 10.3717 1.66667 6.63916C1.60971 5.58476 1.97198 4.5506 2.67448 3.76224C3.37697 2.97389 4.3627 2.49529 5.41667 2.43083C6.47064 2.49529 7.45637 2.97389 8.15887 3.76224C8.86137 4.5506 9.22364 5.58476 9.16667 6.63916H10.8333C10.7764 5.58476 11.1386 4.5506 11.8411 3.76224C12.5436 2.97389 13.5294 2.49529 14.5833 2.43083C15.6373 2.49529 16.623 2.97389 17.3255 3.76224C18.028 4.5506 18.3903 5.58476 18.3333 6.63916C18.3333 10.3733 12.7108 15.3467 10 17.3717Z"
          fill="#718096"
        />
      </g>
      <defs>
        <clipPath id="clip0_166_520">
          <rect width={20} height={20} fill="white" />
        </clipPath>
      </defs>
    </svg>



  );
};
const LocationGreySvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0833 8.75038C12.0833 7.59932 11.1506 6.66663 10.0004 6.66663C8.84936 6.66663 7.91666 7.59932 7.91666 8.75038C7.91666 9.9006 8.84936 10.8333 10.0004 10.8333C11.1506 10.8333 12.0833 9.9006 12.0833 8.75038Z"
        stroke="#ffffffb7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99959 17.5C9.00086 17.5 3.75 13.2486 3.75 8.80274C3.75 5.3222 6.54758 2.5 9.99959 2.5C13.4516 2.5 16.25 5.3222 16.25 8.80274C16.25 13.2486 10.9983 17.5 9.99959 17.5Z"
        stroke="#FFFFFFA6"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>





  );
};
const ClockSvg = () => {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_166_516)">
        <path
          d="M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389957 7.20038 -0.17433 9.00998 0.172937 10.7558C0.520204 12.5016 1.37737 14.1053 2.63604 15.364C3.89472 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C17.9974 6.61384 17.0484 4.32616 15.3611 2.63889C13.6738 0.951621 11.3862 0.00258081 9 0ZM9 16.5C7.51664 16.5 6.0666 16.0601 4.83323 15.236C3.59986 14.4119 2.63856 13.2406 2.07091 11.8701C1.50325 10.4997 1.35473 8.99168 1.64411 7.53682C1.9335 6.08197 2.64781 4.74559 3.6967 3.6967C4.7456 2.64781 6.08197 1.9335 7.53683 1.64411C8.99168 1.35472 10.4997 1.50325 11.8701 2.0709C13.2406 2.63856 14.4119 3.59985 15.236 4.83322C16.0601 6.06659 16.5 7.51664 16.5 9C16.4978 10.9885 15.7069 12.8948 14.3009 14.3009C12.8948 15.7069 10.9885 16.4978 9 16.5Z"
          fill="#718096"
        />
        <path
          d="M8.99984 4.5C8.80093 4.5 8.61016 4.57902 8.46951 4.71967C8.32886 4.86032 8.24984 5.05109 8.24984 5.25V8.49375L5.72159 10.0778C5.55251 10.1834 5.43232 10.3518 5.38745 10.5461C5.34258 10.7403 5.37672 10.9444 5.48234 11.1135C5.58796 11.2826 5.75642 11.4028 5.95066 11.4476C6.1449 11.4925 6.34901 11.4584 6.51809 11.3527L9.39809 9.55275C9.5069 9.48457 9.59639 9.3896 9.65798 9.27693C9.71957 9.16425 9.7512 9.03765 9.74984 8.90925V5.25C9.74984 5.05109 9.67082 4.86032 9.53017 4.71967C9.38952 4.57902 9.19875 4.5 8.99984 4.5Z"
          fill="#718096"
        />
      </g>
      <defs>
        <clipPath id="clip0_166_516">
          <rect width={18} height={18} fill="white" />
        </clipPath>
      </defs>
    </svg>

  );
};
const CalenderSvg = () => {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_166_508)">
        <path
          d="M14.25 1.5H13.5V0.75C13.5 0.551088 13.421 0.360322 13.2803 0.21967C13.1397 0.0790176 12.9489 0 12.75 0C12.5511 0 12.3603 0.0790176 12.2197 0.21967C12.079 0.360322 12 0.551088 12 0.75V1.5H6V0.75C6 0.551088 5.92098 0.360322 5.78033 0.21967C5.63968 0.0790176 5.44891 0 5.25 0C5.05109 0 4.86032 0.0790176 4.71967 0.21967C4.57902 0.360322 4.5 0.551088 4.5 0.75V1.5H3.75C2.7558 1.50119 1.80267 1.89666 1.09966 2.59966C0.396661 3.30267 0.00119089 4.2558 0 5.25L0 14.25C0.00119089 15.2442 0.396661 16.1973 1.09966 16.9003C1.80267 17.6033 2.7558 17.9988 3.75 18H14.25C15.2442 17.9988 16.1973 17.6033 16.9003 16.9003C17.6033 16.1973 17.9988 15.2442 18 14.25V5.25C17.9988 4.2558 17.6033 3.30267 16.9003 2.59966C16.1973 1.89666 15.2442 1.50119 14.25 1.5ZM1.5 5.25C1.5 4.65326 1.73705 4.08097 2.15901 3.65901C2.58097 3.23705 3.15326 3 3.75 3H14.25C14.8467 3 15.419 3.23705 15.841 3.65901C16.2629 4.08097 16.5 4.65326 16.5 5.25V6H1.5V5.25ZM14.25 16.5H3.75C3.15326 16.5 2.58097 16.2629 2.15901 15.841C1.73705 15.419 1.5 14.8467 1.5 14.25V7.5H16.5V14.25C16.5 14.8467 16.2629 15.419 15.841 15.841C15.419 16.2629 14.8467 16.5 14.25 16.5Z"
          fill="#718096"
        />
        <path
          d="M9 12.375C9.62132 12.375 10.125 11.8713 10.125 11.25C10.125 10.6287 9.62132 10.125 9 10.125C8.37868 10.125 7.875 10.6287 7.875 11.25C7.875 11.8713 8.37868 12.375 9 12.375Z"
          fill="#718096"
        />
        <path
          d="M5.25 12.375C5.87132 12.375 6.375 11.8713 6.375 11.25C6.375 10.6287 5.87132 10.125 5.25 10.125C4.62868 10.125 4.125 10.6287 4.125 11.25C4.125 11.8713 4.62868 12.375 5.25 12.375Z"
          fill="#718096"
        />
        <path
          d="M12.75 12.375C13.3713 12.375 13.875 11.8713 13.875 11.25C13.875 10.6287 13.3713 10.125 12.75 10.125C12.1287 10.125 11.625 10.6287 11.625 11.25C11.625 11.8713 12.1287 12.375 12.75 12.375Z"
          fill="#718096"
        />
      </g>
      <defs>
        <clipPath id="clip0_166_508">
          <rect width={18} height={18} fill="white" />
        </clipPath>
      </defs>
    </svg>


  );
};
const UserSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.98736 12.7881C6.76434 12.7881 4.01196 13.2754 4.01196 15.227C4.01196 17.1786 6.74688 17.6833 9.98736 17.6833C13.2104 17.6833 15.962 17.1952 15.962 15.2444C15.962 13.2936 13.2278 12.7881 9.98736 12.7881Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.98741 10.0052C12.1025 10.0052 13.8168 8.29015 13.8168 6.17507C13.8168 4.05999 12.1025 2.3457 9.98741 2.3457C7.87233 2.3457 6.15725 4.05999 6.15725 6.17507C6.15011 8.283 7.85328 9.99808 9.96042 10.0052H9.98741Z"
        stroke="white"
        strokeWidth="1.42857"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>



  );
};
const EditGraySvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.57692 2.32422H6.46108C3.89858 2.32422 2.29192 4.13839 2.29192 6.70672V13.6351C2.29192 16.2034 3.89108 18.0176 6.46108 18.0176H13.8144C16.3852 18.0176 17.9844 16.2034 17.9844 13.6351V10.2784"
        stroke="#555555"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.35651 9.10074L13.584 2.87324C14.3598 2.09824 15.6173 2.09824 16.3932 2.87324L17.4073 3.88741C18.1832 4.66324 18.1832 5.92158 17.4073 6.69658L11.1498 12.9541C10.8107 13.2932 10.3507 13.4841 9.87067 13.4841H6.74901L6.82734 10.3341C6.83901 9.87074 7.02817 9.42908 7.35651 9.10074Z"
        stroke="#555555"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6377 3.83496L16.4427 7.63996"
        stroke="#555555"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

  );
};
const DeleteSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2055 18.3326C9.07629 18.3326 7.97546 18.3201 6.88629 18.2976C5.49296 18.2701 4.52879 17.3668 4.37129 15.9401C4.10879 13.5735 3.65962 7.99514 3.65546 7.93931C3.62712 7.59514 3.88379 7.29348 4.22796 7.26598C4.56712 7.25681 4.87379 7.49514 4.90129 7.83848C4.90546 7.89514 5.35379 13.4543 5.61379 15.8026C5.70296 16.6135 6.14046 17.0318 6.91212 17.0476C8.99546 17.0918 11.1213 17.0943 13.413 17.0526C14.233 17.0368 14.6763 16.6268 14.768 15.7968C15.0263 13.4685 15.4763 7.89514 15.4813 7.83848C15.5088 7.49514 15.813 7.25514 16.1538 7.26598C16.498 7.29431 16.7546 7.59514 16.7271 7.93931C16.7221 7.99598 16.2705 13.5885 16.0105 15.9343C15.8488 17.3901 14.8871 18.276 13.4355 18.3026C12.3246 18.3218 11.253 18.3326 10.2055 18.3326Z"
        fill="#555555"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2567 5.82422H3.125C2.78 5.82422 2.5 5.54422 2.5 5.19922C2.5 4.85422 2.78 4.57422 3.125 4.57422H17.2567C17.6017 4.57422 17.8817 4.85422 17.8817 5.19922C17.8817 5.54422 17.6017 5.82422 17.2567 5.82422Z"
        fill="#555555"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5337 5.82449C13.5854 5.82449 12.7621 5.14866 12.5754 4.21866L12.3729 3.20533C12.3304 3.05116 12.1546 2.91699 11.9546 2.91699H8.42707C8.22707 2.91699 8.05123 3.05116 8.0004 3.24366L7.80623 4.21866C7.6204 5.14866 6.79623 5.82449 5.8479 5.82449C5.5029 5.82449 5.2229 5.54449 5.2229 5.19949C5.2229 4.85449 5.5029 4.57449 5.8479 4.57449C6.2029 4.57449 6.51123 4.32116 6.58123 3.97283L6.78373 2.95949C6.98957 2.18283 7.66207 1.66699 8.42707 1.66699H11.9546C12.7196 1.66699 13.3921 2.18283 13.5896 2.92199L13.8012 3.97283C13.8704 4.32116 14.1787 4.57449 14.5337 4.57449C14.8787 4.57449 15.1587 4.85449 15.1587 5.19949C15.1587 5.54449 14.8787 5.82449 14.5337 5.82449Z"
        fill="#555555"
      />
    </svg>


  );
};
const DeleteRedSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.2064 18.3336C9.07727 18.3336 7.97643 18.3211 6.88727 18.2986C5.49393 18.2711 4.52977 17.3678 4.37227 15.9411C4.10977 13.5745 3.6606 7.99612 3.65643 7.94029C3.6281 7.59612 3.88477 7.29445 4.22893 7.26695C4.5681 7.25779 4.87477 7.49612 4.90227 7.83945C4.90643 7.89612 5.35477 13.4553 5.61477 15.8036C5.70393 16.6145 6.14143 17.0328 6.9131 17.0486C8.99643 17.0928 11.1223 17.0953 13.4139 17.0536C14.2339 17.0378 14.6773 16.6278 14.7689 15.7978C15.0273 13.4695 15.4773 7.89612 15.4823 7.83945C15.5098 7.49612 15.8139 7.25612 16.1548 7.26695C16.4989 7.29529 16.7556 7.59612 16.7281 7.94029C16.7231 7.99695 16.2714 13.5895 16.0114 15.9353C15.8498 17.3911 14.8881 18.277 13.4364 18.3036C12.3256 18.3228 11.2539 18.3336 10.2064 18.3336Z"
        fill="#BA0E22"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2567 5.82471H3.125C2.78 5.82471 2.5 5.54471 2.5 5.19971C2.5 4.85471 2.78 4.57471 3.125 4.57471H17.2567C17.6017 4.57471 17.8817 4.85471 17.8817 5.19971C17.8817 5.54471 17.6017 5.82471 17.2567 5.82471Z"
        fill="#BA0E22"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5335 5.82449C13.5852 5.82449 12.7618 5.14866 12.5752 4.21866L12.3727 3.20533C12.3302 3.05116 12.1543 2.91699 11.9543 2.91699H8.42682C8.22682 2.91699 8.05099 3.05116 8.00016 3.24366L7.80599 4.21866C7.62016 5.14866 6.79599 5.82449 5.84766 5.82449C5.50266 5.82449 5.22266 5.54449 5.22266 5.19949C5.22266 4.85449 5.50266 4.57449 5.84766 4.57449C6.20266 4.57449 6.51099 4.32116 6.58099 3.97283L6.78349 2.95949C6.98932 2.18283 7.66182 1.66699 8.42682 1.66699H11.9543C12.7193 1.66699 13.3918 2.18283 13.5893 2.92199L13.801 3.97283C13.8702 4.32116 14.1785 4.57449 14.5335 4.57449C14.8785 4.57449 15.1585 4.85449 15.1585 5.19949C15.1585 5.54449 14.8785 5.82449 14.5335 5.82449Z"
        fill="#BA0E22"
      />
    </svg>



  );
};
const EyeSmallSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 10C1 10 5 4 10 4C15 4 19 10 19 10C19 10 15 16 10 16C5 16 1 10 1 10Z"
        stroke="#555555"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="10"
        cy="10"
        r="3"
        stroke="#555555"
        strokeWidth="2"
      />
    </svg>
  );
};

const EyeSmallblackSvg = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.3712 9.03947C11.3712 10.349 10.3092 11.4102 8.99966 11.4102C7.69016 11.4102 6.62891 10.349 6.62891 9.03947C6.62891 7.72922 7.69016 6.66797 8.99966 6.66797C10.3092 6.66797 11.3712 7.72922 11.3712 9.03947Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.9985 14.5165C11.8545 14.5165 14.4668 12.463 15.9375 9.03998C14.4668 5.61698 11.8545 3.56348 8.9985 3.56348H9.0015C6.1455 3.56348 3.53325 5.61698 2.0625 9.03998C3.53325 12.463 6.1455 14.5165 9.0015 14.5165H8.9985Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  );
};


const NoteBlackSvg = () => {
  return (
    <svg
      width={22}
      height={22}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4062 15.5593H7.78784C7.40834 15.5593 7.10034 15.2513 7.10034 14.8718C7.10034 14.4923 7.40834 14.1843 7.78784 14.1843H14.4062C14.7857 14.1843 15.0937 14.4923 15.0937 14.8718C15.0937 15.2513 14.7857 15.5593 14.4062 15.5593Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4062 11.7217H7.78784C7.40834 11.7217 7.10034 11.4137 7.10034 11.0342C7.10034 10.6547 7.40834 10.3467 7.78784 10.3467H14.4062C14.7857 10.3467 15.0937 10.6547 15.0937 11.0342C15.0937 11.4137 14.7857 11.7217 14.4062 11.7217Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.313 7.89294H7.7876C7.4081 7.89294 7.1001 7.58494 7.1001 7.20544C7.1001 6.82594 7.4081 6.51794 7.7876 6.51794H10.313C10.6925 6.51794 11.0005 6.82594 11.0005 7.20544C11.0005 7.58494 10.6925 7.89294 10.313 7.89294Z"
        fill="black"
      />
      <mask
        id="mask0_151_1952"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={2}
        y={1}
        width={18}
        height={20}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.75 1.83362H19.401V20.0843H2.75V1.83362Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_151_1952)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.583 3.20837L7.53476 3.21204C5.40076 3.22487 4.12476 4.54487 4.12476 6.74396V15.1736C4.12476 17.3874 5.41267 18.7092 7.56776 18.7092L14.616 18.7065C16.75 18.6936 18.026 17.3718 18.026 15.1736V6.74396C18.026 4.53021 16.739 3.20837 14.583 3.20837ZM7.56867 20.0842C4.68667 20.0842 2.74976 18.1106 2.74976 15.1736V6.74396C2.74976 3.78037 4.62617 1.85446 7.53017 1.83704L14.5821 1.83337H14.583C17.465 1.83337 19.401 3.80696 19.401 6.74396V15.1736C19.401 18.1363 17.5246 20.0631 14.6206 20.0815L7.56867 20.0842Z"
          fill="black"
        />
      </g>
    </svg>



  );
};
const CrossSvg = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.2882 14.9617C16.4644 15.1379 16.5633 15.3767 16.5633 15.6258C16.5633 15.8749 16.4644 16.1137 16.2882 16.2899C16.1121 16.466 15.8733 16.5649 15.6242 16.5649C15.3751 16.5649 15.1362 16.466 14.9601 16.2899L9.99997 11.3281L5.03825 16.2883C4.86213 16.4644 4.62326 16.5634 4.37418 16.5634C4.12511 16.5634 3.88624 16.4644 3.71012 16.2883C3.534 16.1122 3.43506 15.8733 3.43506 15.6242C3.43506 15.3752 3.534 15.1363 3.71012 14.9602L8.67184 10L3.71168 5.0383C3.53556 4.86218 3.43662 4.62331 3.43662 4.37423C3.43662 4.12516 3.53556 3.88629 3.71168 3.71017C3.8878 3.53405 4.12668 3.43511 4.37575 3.43511C4.62482 3.43511 4.86369 3.53405 5.03981 3.71017L9.99997 8.67189L14.9617 3.70939C15.1378 3.53327 15.3767 3.43433 15.6257 3.43433C15.8748 3.43433 16.1137 3.53327 16.2898 3.70939C16.4659 3.88551 16.5649 4.12438 16.5649 4.37345C16.5649 4.62252 16.4659 4.86139 16.2898 5.03751L11.3281 10L16.2882 14.9617Z" fill="white" />
    </svg>



  );
};
const MyProfileSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.9873 12.7885C6.76428 12.7885 4.0119 13.2758 4.0119 15.2274C4.0119 17.179 6.74682 17.6838 9.9873 17.6838C13.2103 17.6838 15.9619 17.1957 15.9619 15.2449C15.9619 13.2941 13.2278 12.7885 9.9873 12.7885Z"
        stroke="#555555"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.98729 10.0049C12.1024 10.0049 13.8167 8.28984 13.8167 6.17476C13.8167 4.05968 12.1024 2.3454 9.98729 2.3454C7.87221 2.3454 6.15713 4.05968 6.15713 6.17476C6.14998 8.2827 7.85316 9.99778 9.9603 10.0049H9.98729Z"
        stroke="#555555"
        strokeWidth="1.42857"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>





  );
};
const MyjobSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99594 14.5219C9.65094 14.5219 9.37094 14.2419 9.37094 13.8969V11.7827C9.37094 11.4377 9.65094 11.1577 9.99594 11.1577C10.3409 11.1577 10.6209 11.4377 10.6209 11.7827V13.8969C10.6209 14.2419 10.3409 14.5219 9.99594 14.5219Z"
        fill="#555555"
      />
      <mask
        id="mask0_165_483"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={1}
        y={3}
        width={18}
        height={10}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.66684 3.81641H18.325V12.4089H1.66684V3.81641Z"
          fill="#555555"
        />
      </mask>
      <g mask="url(#mask0_165_483)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.91684 9.49391C4.89684 10.5697 7.39351 11.1589 9.99184 11.1589C12.5952 11.1589 15.0943 10.5697 17.0752 9.49391V6.99224C17.0752 5.92974 16.216 5.06641 15.1585 5.06641H4.84184C3.78017 5.06641 2.91684 5.92641 2.91684 6.98391V9.49391ZM9.99184 12.4089C7.03767 12.4089 4.19017 11.6939 1.97601 10.3972C1.78434 10.2856 1.66684 10.0806 1.66684 9.85807V6.98391C1.66684 5.23724 3.09101 3.81641 4.84184 3.81641H15.1585C16.9052 3.81641 18.3252 5.24057 18.3252 6.99224V9.85807C18.3252 10.0806 18.2068 10.2856 18.016 10.3972C15.8018 11.6939 12.9518 12.4089 9.99184 12.4089Z"
          fill="#555555"
        />
      </g>
      <mask
        id="mask1_165_483"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={6}
        y={1}
        width={8}
        height={5}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.45425 1.6665H13.5376V5.06309H6.45425V1.6665Z"
          fill="#555555"
        />
      </mask>
      <g mask="url(#mask1_165_483)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.9126 5.06317C12.5676 5.06317 12.2876 4.78317 12.2876 4.43817V4.13317C12.2876 3.46234 11.7418 2.9165 11.0709 2.9165H8.92092C8.25009 2.9165 7.70425 3.46234 7.70425 4.13317V4.43817C7.70425 4.78317 7.42425 5.06317 7.07925 5.06317C6.73425 5.06317 6.45425 4.78317 6.45425 4.43817V4.13317C6.45425 2.77317 7.56092 1.6665 8.92092 1.6665H11.0709C12.4309 1.6665 13.5376 2.77317 13.5376 4.13317V4.43817C13.5376 4.78317 13.2576 5.06317 12.9126 5.06317Z"
          fill="#555555"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8291 18.1168H5.16244C3.43327 18.1168 1.97744 16.766 1.84661 15.041L1.68827 12.9502C1.66244 12.606 1.92077 12.3052 2.26494 12.2793C2.61077 12.2668 2.90911 12.511 2.93577 12.856L3.09327 14.946C3.17494 16.0227 4.08327 16.8668 5.16244 16.8668H14.8291C15.9083 16.8668 16.8174 16.0227 16.8983 14.946L17.0566 12.856C17.0833 12.511 17.3891 12.266 17.7274 12.2793C18.0716 12.3052 18.3291 12.606 18.3033 12.9502L18.1449 15.041C18.0141 16.766 16.5583 18.1168 14.8291 18.1168Z"
        fill="#555555"
      />
    </svg>




  );
};
const UploadjobSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_10_20"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={1}
        y={7}
        width={18}
        height={12}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.66705 7.3284H18.3334V18.7817H1.66705V7.3284Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_10_20)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6379 18.7817H5.36289C3.32539 18.7817 1.66705 17.1242 1.66705 15.0859V11.0234C1.66705 8.9859 3.32539 7.3284 5.36289 7.3284H6.14039C6.48539 7.3284 6.76539 7.6084 6.76539 7.9534C6.76539 8.2984 6.48539 8.5784 6.14039 8.5784H5.36289C4.01372 8.5784 2.91705 9.67507 2.91705 11.0234V15.0859C2.91705 16.4351 4.01372 17.5317 5.36289 17.5317H14.6379C15.9862 17.5317 17.0837 16.4351 17.0837 15.0859V11.0159C17.0837 9.67173 15.9904 8.5784 14.6471 8.5784H13.8612C13.5162 8.5784 13.2362 8.2984 13.2362 7.9534C13.2362 7.6084 13.5162 7.3284 13.8612 7.3284H14.6471C16.6796 7.3284 18.3337 8.98257 18.3337 11.0159V15.0859C18.3337 17.1242 16.6754 18.7817 14.6379 18.7817"
          fill="#555555"
        />
      </g>
      <mask
        id="mask1_10_20"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={9}
        y={1}
        width={2}
        height={12}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.375 1.66675H10.625V12.9508H9.375V1.66675Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_10_20)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 12.9508C9.655 12.9508 9.375 12.6708 9.375 12.3258V2.29166C9.375 1.94666 9.655 1.66666 10 1.66666C10.345 1.66666 10.625 1.94666 10.625 2.29166V12.3258C10.625 12.6708 10.345 12.9508 10 12.9508"
          fill="#555555"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.57084 5.35724C7.41167 5.35724 7.25167 5.29641 7.13001 5.17474C6.88584 4.93141 6.88417 4.5364 7.12834 4.2914L9.55751 1.85141C9.79167 1.61557 10.2083 1.61557 10.4425 1.85141L12.8725 4.2914C13.1158 4.5364 13.115 4.93141 12.8708 5.17474C12.6258 5.41807 12.2308 5.41807 11.9875 5.17307L10 3.17807L8.01334 5.17307C7.89167 5.2964 7.73084 5.35724 7.57084 5.35724"
        fill="#555555"
      />
    </svg>





  );
};
const LogoutSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1592 10.625H3.125C2.78 10.625 2.5 10.345 2.5 10C2.5 9.655 2.78 9.375 3.125 9.375H13.1592C13.5042 9.375 13.7842 9.655 13.7842 10C13.7842 10.345 13.5042 10.625 13.1592 10.625"
        fill="#555555"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7194 13.0542C10.5594 13.0542 10.3986 12.9933 10.2769 12.87C10.0328 12.625 10.0344 12.23 10.2786 11.9867L12.2736 10L10.2786 8.01251C10.0344 7.76918 10.0328 7.37418 10.2769 7.12918C10.5211 6.88418 10.9161 6.88418 11.1603 7.12751L13.6011 9.55751C13.7194 9.67418 13.7853 9.83418 13.7853 10C13.7853 10.1658 13.7194 10.3258 13.6011 10.4425L11.1603 12.8717C11.0386 12.9933 10.8786 13.0542 10.7194 13.0542"
        fill="#555555"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2017 18.3333H10.1308C8.09832 18.3333 6.44415 16.6792 6.44415 14.6458V13.8608C6.44415 13.5158 6.72415 13.2358 7.06915 13.2358C7.41415 13.2358 7.69415 13.5158 7.69415 13.8608V14.6458C7.69415 15.9892 8.78749 17.0833 10.1308 17.0833H14.2017C15.5508 17.0833 16.6483 15.9867 16.6483 14.6367V5.35416C16.6483 4.01082 15.5542 2.91666 14.2108 2.91666H10.14C8.79165 2.91666 7.69415 4.01332 7.69415 5.36166V6.13916C7.69415 6.48416 7.41415 6.76416 7.06915 6.76416C6.72415 6.76416 6.44415 6.48416 6.44415 6.13916V5.36166C6.44415 3.32416 8.10249 1.66666 10.14 1.66666H14.2108C16.2433 1.66666 17.8983 3.32082 17.8983 5.35416V14.6367C17.8983 16.675 16.2392 18.3333 14.2017 18.3333"
        fill="#555555"
      />
    </svg>

  );
};
const EyeOffSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.154 3.09236C16.3922 2.85789 16.7779 2.8581 17.0163 3.09236C17.2546 3.32698 17.2546 3.70736 17.0163 3.94197L3.84637 16.9068C3.72721 17.0241 3.57057 17.0836 3.41473 17.0836C3.25818 17.0835 3.10218 17.024 2.98309 16.9068C2.74511 16.6723 2.74519 16.2929 2.98309 16.0592L7.31317 11.7955C6.94739 11.2705 6.74872 10.651 6.74872 10.0006C6.74876 8.23536 8.20655 6.79958 9.99969 6.79939C10.6554 6.79939 11.2941 6.99814 11.8249 7.35408L13.5202 5.68611C11.1303 4.15545 8.21577 4.28683 5.93915 6.06111C4.73665 6.99218 3.70389 8.35104 2.94305 10.0015C3.28134 10.7389 3.67471 11.419 4.11298 12.026C4.30793 12.2958 4.24442 12.6709 3.9704 12.8629C3.86294 12.9383 3.73933 12.9742 3.61688 12.9742C3.42605 12.9742 3.238 12.887 3.11884 12.7213C2.58397 11.9806 2.11127 11.1448 1.71552 10.2369C1.64974 10.086 1.64984 9.91318 1.71649 9.76228C2.56732 7.82316 3.76601 6.21709 5.18427 5.11873C7.93252 2.97861 11.5422 2.87308 14.3972 4.82283L16.154 3.09236ZM15.8522 6.93416C16.1206 6.73482 16.5024 6.78833 16.7057 7.0533C17.3091 7.84162 17.8387 8.75413 18.2829 9.76228C18.3495 9.91399 18.3495 10.087 18.2829 10.2379C16.5354 14.2236 13.4387 16.6031 9.99969 16.6031C9.21815 16.6031 8.44113 16.479 7.69208 16.233C7.37321 16.1271 7.2009 15.7872 7.30731 15.4732C7.41315 15.1582 7.75796 14.9908 8.0788 15.0933C8.70355 15.2983 9.34996 15.4019 9.99969 15.4019C12.8705 15.4019 15.493 13.3884 17.0563 10.0006C16.6739 9.17298 16.2295 8.42542 15.7321 7.77498C15.5297 7.51008 15.5824 7.13436 15.8522 6.93416ZM12.6999 9.87166C13.0315 9.92996 13.2521 10.2417 13.1921 10.5689C12.9553 11.8715 11.906 12.9051 10.5827 13.1422C10.5462 13.1479 10.5098 13.1509 10.4733 13.151C10.185 13.151 9.92705 12.9483 9.87372 12.6588C9.81387 12.3324 10.0343 12.0204 10.3659 11.9605C11.1908 11.8136 11.8436 11.1681 11.9919 10.356C12.0511 10.0313 12.3708 9.81261 12.6999 9.87166ZM9.99969 7.99959C8.87907 7.99982 7.96749 8.89656 7.96747 10.0006C7.96747 10.3261 8.05582 10.6362 8.20575 10.9176L10.9323 8.23396C10.6473 8.08716 10.3288 7.99959 9.99969 7.99959Z"
        fill="#555555"
      />
    </svg>


  );
};
const HomeSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.63093 17.3095V14.7539C7.63092 14.1039 8.16085 13.5757 8.81743 13.5713H11.2225C11.8822 13.5713 12.417 14.1008 12.417 14.7539V14.7539V17.3174C12.4169 17.8693 12.8618 18.3204 13.4191 18.3333H15.0225C16.6209 18.3333 17.9166 17.0506 17.9166 15.4682V15.4682V8.1982C17.908 7.57569 17.6128 6.99113 17.1149 6.61087L11.6314 2.23776C10.6707 1.47631 9.30509 1.47631 8.34443 2.23776L2.88494 6.6188C2.38513 6.99752 2.08941 7.58306 2.08325 8.20614V15.4682C2.08325 17.0506 3.37898 18.3333 4.97734 18.3333H6.58072C7.15188 18.3333 7.6149 17.875 7.6149 17.3095V17.3095"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>



  );
};
const SearchSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.0917 16.9083L15 13.8417C16.2001 12.3454 16.7813 10.4461 16.6241 8.53443C16.4668 6.62276 15.5831 4.844 14.1546 3.56388C12.7262 2.28377 10.8616 1.5996 8.94415 1.65207C7.02674 1.70454 5.20231 2.48965 3.84599 3.84596C2.48968 5.20228 1.70457 7.02671 1.6521 8.94411C1.59963 10.8615 2.2838 12.7262 3.56391 14.1546C4.84403 15.5831 6.62279 16.4668 8.53446 16.624C10.4461 16.7813 12.3454 16.2001 13.8417 15L16.9084 18.0667C16.9858 18.1448 17.078 18.2068 17.1796 18.2491C17.2811 18.2914 17.39 18.3132 17.5 18.3132C17.6101 18.3132 17.719 18.2914 17.8205 18.2491C17.9221 18.2068 18.0142 18.1448 18.0917 18.0667C18.2419 17.9113 18.3259 17.7036 18.3259 17.4875C18.3259 17.2714 18.2419 17.0637 18.0917 16.9083ZM9.16671 15C8.01299 15 6.88517 14.6579 5.92588 14.0169C4.9666 13.3759 4.21892 12.4649 3.77741 11.399C3.3359 10.3331 3.22038 9.16021 3.44546 8.02865C3.67054 6.8971 4.22611 5.8577 5.04192 5.04189C5.85773 4.22608 6.89713 3.67051 8.02868 3.44543C9.16024 3.22035 10.3331 3.33587 11.399 3.77738C12.4649 4.21889 13.376 4.96657 14.017 5.92585C14.6579 6.88514 15 8.01295 15 9.16668C15 10.7138 14.3855 12.1975 13.2915 13.2915C12.1975 14.3854 10.7138 15 9.16671 15Z"
        fill="#555555"
      />
    </svg>




  );
};

const DownSvg = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.9999 9.17C16.8126 8.98375 16.5591 8.87921 16.2949 8.87921C16.0308 8.87921 15.7773 8.98375 15.5899 9.17L11.9999 12.71L8.45995 9.17C8.27259 8.98375 8.01913 8.87921 7.75495 8.87921C7.49076 8.87921 7.23731 8.98375 7.04995 9.17C6.95622 9.26297 6.88183 9.37357 6.83106 9.49543C6.78029 9.61729 6.75415 9.74799 6.75415 9.88C6.75415 10.012 6.78029 10.1427 6.83106 10.2646C6.88183 10.3864 6.95622 10.497 7.04995 10.59L11.2899 14.83C11.3829 14.9237 11.4935 14.9981 11.6154 15.0489C11.7372 15.0997 11.8679 15.1258 11.9999 15.1258C12.132 15.1258 12.2627 15.0997 12.3845 15.0489C12.5064 14.9981 12.617 14.9237 12.7099 14.83L16.9999 10.59C17.0937 10.497 17.1681 10.3864 17.2188 10.2646C17.2696 10.1427 17.2957 10.012 17.2957 9.88C17.2957 9.74799 17.2696 9.61729 17.2188 9.49543C17.1681 9.37357 17.0937 9.26297 16.9999 9.17Z" fill="black" />
    </svg>


  );
};

const JobGreySvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99585 14.5222C9.65085 14.5222 9.37085 14.2422 9.37085 13.8972V11.7831C9.37085 11.4381 9.65085 11.1581 9.99585 11.1581C10.3408 11.1581 10.6208 11.4381 10.6208 11.7831V13.8972C10.6208 14.2422 10.3408 14.5222 9.99585 14.5222"
        fill="#555555"
      />
      <mask
        id="mask0_154_714"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={1}
        y={3}
        width={18}
        height={10}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.66699 3.81668H18.3252V12.4092H1.66699V3.81668Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_154_714)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.91699 9.49418C4.89699 10.57 7.39366 11.1592 9.99199 11.1592C12.5953 11.1592 15.0945 10.57 17.0753 9.49418V6.99251C17.0753 5.93001 16.2162 5.06668 15.1587 5.06668H4.84199C3.78033 5.06668 2.91699 5.92668 2.91699 6.98418V9.49418ZM9.99199 12.4092C7.03783 12.4092 4.19033 11.6942 1.97616 10.3975C1.78449 10.2858 1.66699 10.0808 1.66699 9.85835V6.98418C1.66699 5.23751 3.09116 3.81668 4.84199 3.81668H15.1587C16.9053 3.81668 18.3253 5.24085 18.3253 6.99251V9.85835C18.3253 10.0808 18.207 10.2858 18.0162 10.3975C15.802 11.6942 12.952 12.4092 9.99199 12.4092V12.4092Z"
          fill="#555555"
        />
      </g>
      <mask
        id="mask1_154_714"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={6}
        y={1}
        width={8}
        height={5}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.45435 1.66684H13.5377V5.06342H6.45435V1.66684Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_154_714)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.9127 5.06345C12.5677 5.06345 12.2877 4.78345 12.2877 4.43845V4.13345C12.2877 3.46261 11.7418 2.91678 11.071 2.91678H8.92101C8.25018 2.91678 7.70435 3.46261 7.70435 4.13345V4.43845C7.70435 4.78345 7.42435 5.06345 7.07935 5.06345C6.73435 5.06345 6.45435 4.78345 6.45435 4.43845V4.13345C6.45435 2.77345 7.56101 1.66678 8.92101 1.66678H11.071C12.431 1.66678 13.5377 2.77345 13.5377 4.13345V4.43845C13.5377 4.78345 13.2577 5.06345 12.9127 5.06345"
          fill="#555555"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8291 18.1169H5.16247C3.4333 18.1169 1.97747 16.766 1.84664 15.041L1.6883 12.9502C1.66247 12.606 1.9208 12.3052 2.26497 12.2794C2.6108 12.2669 2.90914 12.511 2.9358 12.856L3.0933 14.946C3.17497 16.0227 4.0833 16.8669 5.16247 16.8669H14.8291C15.9083 16.8669 16.8175 16.0227 16.8983 14.946L17.0566 12.856C17.0833 12.511 17.3891 12.266 17.7275 12.2794C18.0716 12.3052 18.3291 12.606 18.3033 12.9502L18.145 15.041C18.0141 16.766 16.5583 18.1169 14.8291 18.1169"
        fill="#555555"
      />
    </svg>

  );
};
const CheckSvg = () => {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_154_1641)">
        <path
          d="M16.3507 7.49999C16.6932 9.18097 16.4491 10.9286 15.6591 12.4513C14.8691 13.9741 13.5809 15.18 12.0093 15.868C10.4378 16.5559 8.67792 16.6843 7.02318 16.2318C5.36843 15.7792 3.91885 14.773 2.91616 13.3811C1.91347 11.9891 1.41829 10.2954 1.5132 8.58253C1.60811 6.86964 2.28736 5.24106 3.43769 3.96837C4.58802 2.69568 6.13989 1.85582 7.8345 1.58883C9.52912 1.32185 11.264 1.64389 12.75 2.50124"
          stroke="#555555"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.75 8.25L9 10.5L16.5 3"
          stroke="#555555"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_154_1641">
          <rect width={18} height={18} fill="white" />
        </clipPath>
      </defs>
    </svg>


  );
};
const LocationSmallSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0832 8.75026C12.0832 7.5992 11.1505 6.6665 10.0003 6.6665C8.8492 6.6665 7.9165 7.5992 7.9165 8.75026C7.9165 9.90047 8.8492 10.8332 10.0003 10.8332C11.1505 10.8332 12.0832 9.90047 12.0832 8.75026Z"
        stroke="#555555"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99959 17.5C9.00086 17.5 3.75 13.2486 3.75 8.80274C3.75 5.3222 6.54758 2.5 9.99959 2.5C13.4516 2.5 16.25 5.3222 16.25 8.80274C16.25 13.2486 10.9983 17.5 9.99959 17.5Z"
        stroke="#555555"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>


  );
};
const LikedSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_176_2490)">
        <path
          d="M6.5 15.5L10 18.5L11.5 17.5L12.5 16L14.5 14.5L15.5 13L17 11.5L18 10L18.5 8V6.5V4.5L17.5 3.5L16.5 2H15H14L12 2.5L11.5 3.5L10.5 4.5L10 6L9 4L8 3L7 2L5 1.5L1.5 4L1 8L3 12L6.5 15.5Z"
          fill="black"
        />
        <path
          d="M14.5835 0.76416C13.6451 0.778756 12.7272 1.0407 11.9224 1.52355C11.1177 2.0064 10.4546 2.69305 10.0001 3.51416C9.54566 2.69305 8.88257 2.0064 8.07783 1.52355C7.27308 1.0407 6.35517 0.778756 5.41679 0.76416C3.92091 0.829152 2.51155 1.48354 1.49661 2.58435C0.481678 3.68517 -0.0563308 5.14293 0.000128002 6.63916C0.000128002 12.285 9.13013 18.8058 9.51846 19.0825L10.0001 19.4233L10.4818 19.0825C10.8701 18.8075 20.0001 12.285 20.0001 6.63916C20.0566 5.14293 19.5186 3.68517 18.5036 2.58435C17.4887 1.48354 16.0793 0.829152 14.5835 0.76416ZM10.0001 17.3717C7.28929 15.3467 1.66679 10.3717 1.66679 6.63916C1.60983 5.58476 1.9721 4.5506 2.6746 3.76224C3.37709 2.97389 4.36282 2.49529 5.41679 2.43083C6.47077 2.49529 7.45649 2.97389 8.15899 3.76224C8.86149 4.5506 9.22376 5.58476 9.16679 6.63916H10.8335C10.7765 5.58476 11.1388 4.5506 11.8413 3.76224C12.5438 2.97389 13.5295 2.49529 14.5835 2.43083C15.6374 2.49529 16.6232 2.97389 17.3257 3.76224C18.0282 4.5506 18.3904 5.58476 18.3335 6.63916C18.3335 10.3733 12.711 15.3467 10.0001 17.3717Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_176_2490">
          <rect width={20} height={20} fill="white" />
        </clipPath>
      </defs>
    </svg>


  );
};
const LikeSvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.16 4.99998C19.1 3.93719 17.6948 3.28852 16.1984 3.17115C14.7019 3.05378 13.2128 3.47545 12 4.35998C10.7277 3.41362 9.14402 2.98449 7.56795 3.15902C5.99188 3.33355 4.54047 4.09876 3.506 5.30057C2.47154 6.50237 1.93085 8.0515 1.99283 9.636C2.05481 11.2205 2.71485 12.7227 3.84003 13.84L10.05 20.06C10.57 20.5718 11.2704 20.8586 12 20.8586C12.7296 20.8586 13.43 20.5718 13.95 20.06L20.16 13.84C21.3276 12.6652 21.983 11.0763 21.983 9.41998C21.983 7.76371 21.3276 6.17472 20.16 4.99998ZM18.75 12.46L12.54 18.67C12.4694 18.7413 12.3853 18.798 12.2926 18.8366C12.1999 18.8753 12.1005 18.8952 12 18.8952C11.8996 18.8952 11.8002 18.8753 11.7075 18.8366C11.6148 18.798 11.5307 18.7413 11.46 18.67L5.25003 12.43C4.46579 11.6283 4.02664 10.5514 4.02664 9.42998C4.02664 8.30852 4.46579 7.23164 5.25003 6.42998C6.04919 5.64097 7.127 5.19855 8.25003 5.19855C9.37306 5.19855 10.4509 5.64097 11.25 6.42998C11.343 6.52371 11.4536 6.59811 11.5755 6.64887C11.6973 6.69964 11.828 6.72578 11.96 6.72578C12.092 6.72578 12.2227 6.69964 12.3446 6.64887C12.4665 6.59811 12.5771 6.52371 12.67 6.42998C13.4692 5.64097 14.547 5.19855 15.67 5.19855C16.7931 5.19855 17.8709 5.64097 18.67 6.42998C19.4651 7.22113 19.9186 8.29217 19.9336 9.41367C19.9485 10.5352 19.5237 11.6179 18.75 12.43V12.46Z"
        fill="black"
      />
    </svg>



  );
};
const LikeGreySvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.1603 4.60981C19.0986 3.54782 17.691 2.90214 16.1935 2.79019C14.696 2.67825 13.2081 3.10748 12.0003 3.99981C10.7279 3.05345 9.14427 2.62433 7.5682 2.79885C5.99212 2.97338 4.54072 3.73859 3.50625 4.9404C2.47178 6.14221 1.9311 7.69133 1.99308 9.27583C2.05506 10.8603 2.71509 12.3625 3.84028 13.4798L11.2903 20.9298C11.3832 21.0235 11.4938 21.0979 11.6157 21.1487C11.7376 21.1995 11.8683 21.2256 12.0003 21.2256C12.1323 21.2256 12.263 21.1995 12.3849 21.1487C12.5067 21.0979 12.6173 21.0235 12.7103 20.9298L20.1603 13.4798C20.7429 12.8975 21.2051 12.2062 21.5205 11.4452C21.8358 10.6842 21.9982 9.86854 21.9982 9.04481C21.9982 8.22108 21.8358 7.40542 21.5205 6.64445C21.2051 5.88347 20.7429 5.19209 20.1603 4.60981ZM18.7503 12.0698L12.0003 18.8098L5.25028 12.0698C4.65545 11.4725 4.25025 10.7129 4.0855 9.88615C3.92076 9.05945 4.00381 8.2025 4.32423 7.42281C4.64465 6.64312 5.18817 5.97541 5.88662 5.50344C6.58507 5.03147 7.40734 4.77625 8.25028 4.76981C9.37639 4.77257 10.4554 5.22215 11.2503 6.01981C11.3432 6.11354 11.4538 6.18794 11.5757 6.23871C11.6976 6.28947 11.8283 6.31561 11.9603 6.31561C12.0923 6.31561 12.223 6.28947 12.3449 6.23871C12.4667 6.18794 12.5773 6.11354 12.6703 6.01981C13.4886 5.3107 14.5458 4.93896 15.6278 4.97984C16.7099 5.02072 17.736 5.47116 18.4985 6.24C19.2609 7.00884 19.7029 8.03865 19.7348 9.121C19.7667 10.2034 19.3862 11.2574 18.6703 12.0698H18.7503Z"
        fill="#5C5C5C"
      />
    </svg>




  );
};
const JobBlackSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99589 13.8974V11.7832"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1582 4.44238C16.5665 4.44238 17.6998 5.58405 17.6998 6.99238V9.85905C15.6498 11.059 12.9415 11.7841 9.9915 11.7841C7.0415 11.7841 4.3415 11.059 2.2915 9.85905V6.98405C2.2915 5.57572 3.43317 4.44238 4.8415 4.44238H15.1582Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9126 4.43866V4.13366C12.9126 3.11699 12.0876 2.29199 11.0709 2.29199H8.92089C7.90422 2.29199 7.07922 3.11699 7.07922 4.13366V4.43866"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.31201 12.9023L2.46951 14.9932C2.57618 16.4023 3.75035 17.4915 5.16285 17.4915H14.8287C16.2412 17.4915 17.4153 16.4023 17.522 14.9932L17.6795 12.9023"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>



  );
};
const DownloadWhiteSvg = () => {
  return (
    <svg
      width={20}
      height={19}
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0007 13.541C9.58673 13.541 9.25073 13.205 9.25073 12.791V0.75C9.25073 0.336 9.58673 0 10.0007 0C10.4147 0 10.7507 0.336 10.7507 0.75V12.791C10.7507 13.205 10.4147 13.541 10.0007 13.541Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0008 13.541C9.80183 13.541 9.60983 13.462 9.46983 13.32L6.55383 10.393C6.26183 10.099 6.26283 9.62403 6.55583 9.33203C6.84983 9.04003 7.32383 9.04003 7.61583 9.33403L10.0008 11.729L12.3858 9.33403C12.6778 9.04003 13.1518 9.04003 13.4458 9.33203C13.7388 9.62403 13.7398 10.099 13.4478 10.393L10.5318 13.32C10.3918 13.462 10.1998 13.541 10.0008 13.541Z"
        fill="white"
      />
      <mask
        id="mask0_187_5173"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={4}
        width={20}
        height={15}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 4.73242H19.9998V18.4764H0V4.73242Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_187_5173)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.575 18.4764H4.435C1.99 18.4764 0 16.4874 0 14.0414V9.15642C0 6.71642 1.985 4.73242 4.426 4.73242H5.367C5.781 4.73242 6.117 5.06842 6.117 5.48242C6.117 5.89642 5.781 6.23242 5.367 6.23242H4.426C2.812 6.23242 1.5 7.54342 1.5 9.15642V14.0414C1.5 15.6604 2.816 16.9764 4.435 16.9764H15.575C17.187 16.9764 18.5 15.6634 18.5 14.0514V9.16742C18.5 7.54842 17.183 6.23242 15.566 6.23242H14.634C14.22 6.23242 13.884 5.89642 13.884 5.48242C13.884 5.06842 14.22 4.73242 14.634 4.73242H15.566C18.011 4.73242 20 6.72242 20 9.16742V14.0514C20 16.4914 18.014 18.4764 15.575 18.4764Z"
          fill="white"
        />
      </g>
    </svg>


  );
};
const UserBlack = () => {
  return (
    <svg
      width={22}
      height={22}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.986 14.0674C7.4407 14.0674 4.41309 14.6034 4.41309 16.7502C4.41309 18.8969 7.4215 19.4521 10.986 19.4521C14.5313 19.4521 17.5581 18.9152 17.5581 16.7694C17.5581 14.6235 14.5505 14.0674 10.986 14.0674Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.986 11.0056C13.3126 11.0056 15.1983 9.11897 15.1983 6.79238C15.1983 4.46579 13.3126 2.58008 10.986 2.58008C8.65944 2.58008 6.77285 4.46579 6.77285 6.79238C6.76499 9.11111 8.63849 10.9977 10.9563 11.0056H10.986Z"
        stroke="black"
        strokeWidth="1.42857"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>


  );
};
const SearchnewSvg = () => {
  return (
    <svg
      width={19}
      height={19}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_191_2128"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={1}
        y={1}
        width={17}
        height={17}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.5835 1.58301H17.0026V17.0023H1.5835V1.58301Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_191_2128)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.29305 2.77051C5.69651 2.77051 2.77051 5.69572 2.77051 9.29226C2.77051 12.8888 5.69651 15.8148 9.29305 15.8148C12.8888 15.8148 15.8148 12.8888 15.8148 9.29226C15.8148 5.69572 12.8888 2.77051 9.29305 2.77051ZM9.29305 17.0023C5.0418 17.0023 1.58301 13.5435 1.58301 9.29226C1.58301 5.04101 5.0418 1.58301 9.29305 1.58301C13.5443 1.58301 17.0023 5.04101 17.0023 9.29226C17.0023 13.5435 13.5443 17.0023 9.29305 17.0023Z"
          fill="black"
        />
      </g>
      <mask
        id="mask1_191_2128"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={13}
        y={14}
        width={5}
        height={4}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6479 14.0186H17.6253V17.9886H13.6479V14.0186Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_191_2128)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.0317 17.9886C16.8805 17.9886 16.7285 17.9308 16.6121 17.8152L13.8223 15.0333C13.5904 14.8013 13.5896 14.4253 13.8215 14.1933C14.0527 13.9598 14.4287 13.9614 14.6615 14.1917L17.4513 16.9744C17.6833 17.2064 17.6841 17.5816 17.4521 17.8136C17.3365 17.9308 17.1837 17.9886 17.0317 17.9886Z"
          fill="black"
        />
      </g>
    </svg>


  );
};
const ExportSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.25817 6.42508L9.1665 4.50841V12.5001C9.1665 12.7211 9.2543 12.9331 9.41058 13.0893C9.56686 13.2456 9.77882 13.3334 9.99984 13.3334C10.2208 13.3334 10.4328 13.2456 10.5891 13.0893C10.7454 12.9331 10.8332 12.7211 10.8332 12.5001V4.50841L12.7415 6.42508C12.819 6.50318 12.9111 6.56518 13.0127 6.60749C13.1142 6.64979 13.2232 6.67157 13.3332 6.67157C13.4432 6.67157 13.5521 6.64979 13.6536 6.60749C13.7552 6.56518 13.8474 6.50318 13.9248 6.42508C14.0029 6.34761 14.0649 6.25544 14.1072 6.15389C14.1496 6.05234 14.1713 5.94342 14.1713 5.83341C14.1713 5.7234 14.1496 5.61448 14.1072 5.51293C14.0649 5.41138 14.0029 5.31921 13.9248 5.24174L10.5915 1.90841C10.5122 1.83254 10.4188 1.77307 10.3165 1.73341C10.1136 1.65006 9.88605 1.65006 9.68317 1.73341C9.58088 1.77307 9.48742 1.83254 9.40817 1.90841L6.07484 5.24174C5.99714 5.31944 5.9355 5.41168 5.89345 5.5132C5.8514 5.61472 5.82976 5.72353 5.82976 5.83341C5.82976 5.94329 5.8514 6.0521 5.89345 6.15362C5.9355 6.25514 5.99714 6.34738 6.07484 6.42508C6.15254 6.50277 6.24478 6.56441 6.3463 6.60646C6.44781 6.64851 6.55662 6.67015 6.6665 6.67015C6.77639 6.67015 6.88519 6.64851 6.98671 6.60646C7.08823 6.56441 7.18047 6.50277 7.25817 6.42508ZM17.4998 11.6667C17.2788 11.6667 17.0669 11.7545 16.9106 11.9108C16.7543 12.0671 16.6665 12.2791 16.6665 12.5001V15.8334C16.6665 16.0544 16.5787 16.2664 16.4224 16.4227C16.2661 16.5789 16.0542 16.6667 15.8332 16.6667H4.1665C3.94549 16.6667 3.73353 16.5789 3.57725 16.4227C3.42097 16.2664 3.33317 16.0544 3.33317 15.8334V12.5001C3.33317 12.2791 3.24537 12.0671 3.08909 11.9108C2.93281 11.7545 2.72085 11.6667 2.49984 11.6667C2.27882 11.6667 2.06686 11.7545 1.91058 11.9108C1.7543 12.0671 1.6665 12.2791 1.6665 12.5001V15.8334C1.6665 16.4965 1.9299 17.1323 2.39874 17.6012C2.86758 18.07 3.50346 18.3334 4.1665 18.3334H15.8332C16.4962 18.3334 17.1321 18.07 17.6009 17.6012C18.0698 17.1323 18.3332 16.4965 18.3332 15.8334V12.5001C18.3332 12.2791 18.2454 12.0671 18.0891 11.9108C17.9328 11.7545 17.7208 11.6667 17.4998 11.6667Z"
        fill="#142A49"
      />
    </svg>



  );
};
const DownloadSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0005 13.7842C9.65549 13.7842 9.37549 13.5042 9.37549 13.1592V3.125C9.37549 2.78 9.65549 2.5 10.0005 2.5C10.3455 2.5 10.6255 2.78 10.6255 3.125V13.1592C10.6255 13.5042 10.3455 13.7842 10.0005 13.7842Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0008 13.7845C9.83494 13.7845 9.67494 13.7187 9.55827 13.6004L7.12827 11.1612C6.88494 10.9162 6.88577 10.5204 7.12994 10.277C7.37494 10.0337 7.76994 10.0337 8.01327 10.2787L10.0008 12.2745L11.9883 10.2787C12.2316 10.0337 12.6266 10.0337 12.8716 10.277C13.1158 10.5204 13.1166 10.9162 12.8733 11.1612L10.4433 13.6004C10.3266 13.7187 10.1666 13.7845 10.0008 13.7845Z"
        fill="black"
      />
      <mask
        id="mask0_191_2021"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={1}
        y={6}
        width={18}
        height={12}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.6665 6.44336H18.333V17.8967H1.6665V6.44336Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_191_2021)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.6457 17.8967H5.36234C3.32484 17.8967 1.6665 16.2392 1.6665 14.2009V10.13C1.6665 8.09669 3.32067 6.44336 5.35484 6.44336H6.139C6.484 6.44336 6.764 6.72336 6.764 7.06836C6.764 7.41336 6.484 7.69336 6.139 7.69336H5.35484C4.00984 7.69336 2.9165 8.78586 2.9165 10.13V14.2009C2.9165 15.55 4.01317 16.6467 5.36234 16.6467H14.6457C15.989 16.6467 17.0832 15.5525 17.0832 14.2092V10.1392C17.0832 8.79003 15.9857 7.69336 14.6382 7.69336H13.8615C13.5165 7.69336 13.2365 7.41336 13.2365 7.06836C13.2365 6.72336 13.5165 6.44336 13.8615 6.44336H14.6382C16.6757 6.44336 18.3332 8.10169 18.3332 10.1392V14.2092C18.3332 16.2425 16.6782 17.8967 14.6457 17.8967Z"
          fill="black"
        />
      </g>
    </svg>




  );
};
const SaveSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.449 5.12738C16.449 2.83498 14.8818 1.91602 12.6253 1.91602H7.32623C5.1391 1.91602 3.5 2.77232 3.5 4.9745V17.2443C3.5 17.8492 4.15079 18.2301 4.67794 17.9344L9.99624 14.9511L15.2686 17.9294C15.7966 18.2268 16.449 17.8458 16.449 17.2402V5.12738Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.89258 7.52318H12.9912"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>


  );
};
const RasedSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3983 11.5743C14.9605 11.5743 15.4325 12.0383 15.3465 12.5936C14.8421 15.8603 12.0456 18.2857 8.67281 18.2857C4.94123 18.2857 1.91667 15.2611 1.91667 11.5304C1.91667 8.45674 4.25176 5.59359 6.88071 4.94622C7.44562 4.80674 8.02457 5.20411 8.02457 5.78569C8.02457 9.72604 8.15702 10.7453 8.90527 11.2997C9.65351 11.8541 10.5333 11.5743 14.3983 11.5743Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0771 8.293C18.1218 5.76142 15.0122 1.68072 11.2227 1.75089C10.928 1.75616 10.692 2.00177 10.6789 2.29563C10.5832 4.37721 10.7122 7.07458 10.7841 8.29738C10.8061 8.67809 11.1052 8.97721 11.485 8.99914C12.742 9.07107 15.5376 9.16931 17.5894 8.85879C17.8683 8.81668 18.0727 8.57458 18.0771 8.293Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>



  );
};
const WorkSvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9951 17.4266C11.5811 17.4266 11.2451 17.0906 11.2451 16.6766V14.1396C11.2451 13.7256 11.5811 13.3896 11.9951 13.3896C12.4091 13.3896 12.7451 13.7256 12.7451 14.1396V16.6766C12.7451 17.0906 12.4091 17.4266 11.9951 17.4266Z"
        fill="#ffffff"
      />
      <mask
        id="mask0_297_2921"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={2}
        y={4}
        width={20}
        height={11}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.0002 4.57959H21.99V14.8906H2.0002V4.57959Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_297_2921)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.5002 11.3926C5.8762 12.6836 8.8722 13.3906 11.9902 13.3906C15.1142 13.3906 18.1132 12.6836 20.4902 11.3926V8.39059C20.4902 7.11559 19.4592 6.07959 18.1902 6.07959H5.8102C4.5362 6.07959 3.5002 7.11159 3.5002 8.38059V11.3926ZM11.9902 14.8906C8.4452 14.8906 5.0282 14.0326 2.3712 12.4766C2.1412 12.3426 2.0002 12.0966 2.0002 11.8296V8.38059C2.0002 6.28459 3.7092 4.57959 5.8102 4.57959H18.1902C20.2862 4.57959 21.9902 6.28859 21.9902 8.39059V11.8296C21.9902 12.0966 21.8482 12.3426 21.6192 12.4766C18.9622 14.0326 15.5422 14.8906 11.9902 14.8906Z"
          fill="#ffffff"
        />
      </g>
      <mask
        id="mask1_297_2921"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={7}
        y={2}
        width={10}
        height={5}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.7451 2H16.2451V6.0759H7.7451V2Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_297_2921)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.4951 6.076C15.0811 6.076 14.7451 5.74 14.7451 5.326V4.96C14.7451 4.155 14.0901 3.5 13.2851 3.5H10.7051C9.9001 3.5 9.2451 4.155 9.2451 4.96V5.326C9.2451 5.74 8.9091 6.076 8.4951 6.076C8.0811 6.076 7.7451 5.74 7.7451 5.326V4.96C7.7451 3.328 9.0731 2 10.7051 2H13.2851C14.9171 2 16.2451 3.328 16.2451 4.96V5.326C16.2451 5.74 15.9091 6.076 15.4951 6.076Z"
          fill="#ffffff"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7949 21.74H6.19489C4.11989 21.74 2.37289 20.119 2.21589 18.049L2.02589 15.54C1.99489 15.127 2.30489 14.766 2.71789 14.735C3.13289 14.72 3.49089 15.013 3.52289 15.427L3.71189 17.935C3.80989 19.227 4.89989 20.24 6.19489 20.24H17.7949C19.0899 20.24 20.1809 19.227 20.2779 17.935L20.4679 15.427C20.4999 15.013 20.8669 14.719 21.2729 14.735C21.6859 14.766 21.9949 15.127 21.9639 15.54L21.7739 18.049C21.6169 20.119 19.8699 21.74 17.7949 21.74Z"
        fill="#ffffff"
      />
    </svg>

  );
};
const GpsSvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <mask
        id="mask0_2_517"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <rect width={24} height={24} fill="url(#pattern0_2_517)" />
      </mask>
      <g mask="url(#mask0_2_517)">
        <rect x={-4} y={-3} width={34} height={31} fill="white" />
      </g>
      <defs>
        <pattern
          id="pattern0_2_517"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use xlinkHref="#image0_2_517" transform="scale(0.00195312)" />
        </pattern>
        <image
          id="image0_2_517"
          width={512}
          height={512}
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>


  );
};
const FourboxSvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 3.5C3.5 3.5 3.5 3.708 3.5 6.25V6.275C3.5 7.382 3.5 8.182 3.771 8.52C4.036 8.848 4.823 9 6.25 9C7.677 9 8.464 8.847 8.729 8.519C9 8.182 9 7.382 9 6.274C9 3.708 9 3.5 6.25 3.5ZM6.25 10.5C4.564 10.5 3.299 10.323 2.604 9.46C2 8.711 2 7.689 2 6.275L2.75 6.25H2C2 3.38 2.181 2 6.25 2C10.319 2 10.5 3.38 10.5 6.25C10.5 7.688 10.5 8.711 9.896 9.46C9.201 10.323 7.936 10.5 6.25 10.5Z"
        fill="#ffffff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.25 3.5C14.5 3.5 14.5 3.708 14.5 6.25V6.275C14.5 7.382 14.5 8.182 14.771 8.52C15.036 8.848 15.823 9 17.25 9C18.677 9 19.464 8.847 19.729 8.519C20 8.182 20 7.382 20 6.274C20 3.708 20 3.5 17.25 3.5ZM17.25 10.5C15.564 10.5 14.299 10.323 13.604 9.46C13 8.711 13 7.689 13 6.275L13.75 6.25H13C13 3.38 13.181 2 17.25 2C21.319 2 21.5 3.38 21.5 6.25C21.5 7.688 21.5 8.711 20.896 9.46C20.201 10.323 18.936 10.5 17.25 10.5Z"
        fill="#ffffff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 14.5C3.5 14.5 3.5 14.708 3.5 17.25V17.275C3.5 18.382 3.5 19.182 3.771 19.52C4.036 19.848 4.823 20 6.25 20C7.677 20 8.464 19.847 8.729 19.519C9 19.182 9 18.382 9 17.274C9 14.708 9 14.5 6.25 14.5ZM6.25 21.5C4.564 21.5 3.299 21.323 2.604 20.46C2 19.711 2 18.689 2 17.275L2.75 17.25H2C2 14.38 2.181 13 6.25 13C10.319 13 10.5 14.38 10.5 17.25C10.5 18.688 10.5 19.711 9.896 20.46C9.201 21.323 7.936 21.5 6.25 21.5Z"
        fill="#ffffff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.25 14.5C14.5 14.5 14.5 14.708 14.5 17.25V17.275C14.5 18.382 14.5 19.182 14.771 19.52C15.036 19.848 15.823 20 17.25 20C18.677 20 19.464 19.847 19.729 19.519C20 19.182 20 18.382 20 17.274C20 14.708 20 14.5 17.25 14.5ZM17.25 21.5C15.564 21.5 14.299 21.323 13.604 20.46C13 19.711 13 18.689 13 17.275L13.75 17.25H13C13 14.38 13.181 13 17.25 13C21.319 13 21.5 14.38 21.5 17.25C21.5 18.688 21.5 19.711 20.896 20.46C20.201 21.323 18.936 21.5 17.25 21.5Z"
        fill="#ffffff"
      />
    </svg>

  );
};
const EmailgreySvg = () => {
  return (
    <svg
      width={22}
      height={22}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4108 8.11377L12.3378 11.4257C11.5683 12.0362 10.4856 12.0362 9.71603 11.4257L5.60864 8.11377"
        stroke="#555555"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4997 19.25C18.2876 19.2577 20.1666 16.9671 20.1666 14.1518V7.85584C20.1666 5.04059 18.2876 2.75 15.4997 2.75H6.50013C3.71222 2.75 1.83325 5.04059 1.83325 7.85584V14.1518C1.83325 16.9671 3.71222 19.2577 6.50013 19.25H15.4997Z"
        stroke="#555555"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

  );
};
const FourBoxGreySvg = () => {
  return (
    <svg
      width={22}
      height={22}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.75 5.95833C2.75 3.55189 2.77577 2.75 5.95833 2.75C9.1409 2.75 9.16667 3.55189 9.16667 5.95833C9.16667 8.36478 9.17682 9.16667 5.95833 9.16667C2.73985 9.16667 2.75 8.36478 2.75 5.95833Z"
        stroke="#555555"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.833 5.95833C12.833 3.55189 12.8588 2.75 16.0413 2.75C19.2239 2.75 19.2497 3.55189 19.2497 5.95833C19.2497 8.36478 19.2598 9.16667 16.0413 9.16667C12.8229 9.16667 12.833 8.36478 12.833 5.95833Z"
        stroke="#555555"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.75 16.0418C2.75 13.6354 2.77577 12.8335 5.95833 12.8335C9.1409 12.8335 9.16667 13.6354 9.16667 16.0418C9.16667 18.4483 9.17682 19.2502 5.95833 19.2502C2.73985 19.2502 2.75 18.4483 2.75 16.0418Z"
        stroke="#555555"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.833 16.0418C12.833 13.6354 12.8588 12.8335 16.0413 12.8335C19.2239 12.8335 19.2497 13.6354 19.2497 16.0418C19.2497 18.4483 19.2598 19.2502 16.0413 19.2502C12.8229 19.2502 12.833 18.4483 12.833 16.0418Z"
        stroke="#555555"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>


  );
};
const WalletSvg = () => {
  return (
    <svg
      width={22}
      height={22}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width={22} height={22} fill="url(#pattern0_250_1907)" />
      <defs>
        <pattern
          id="pattern0_250_1907"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use xlinkHref="#image0_250_1907" transform="scale(0.00195312)" />
        </pattern>
        <image
          id="image0_250_1907"
          width={512}
          height={512}
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </svg>



  );
};
const GreenarrowSvg = () => {
  return (
    <svg
      width={22}
      height={22}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10.8781" cy="10.8781" r="10.8781" fill="#04CE00" />
      <path
        d="M13.3203 9.71918L13.0284 10.0111C11.4664 11.573 9.90436 13.1351 8.34213 14.6973C8.0261 15.0133 7.6527 15.0826 7.27975 14.91C6.92046 14.741 6.72328 14.4318 6.77565 14.058C6.8227 13.7879 6.95014 13.5382 7.14132 13.3417C8.65178 11.8039 10.1818 10.2857 11.706 8.76154L11.9947 8.47283C11.9015 8.45691 11.8076 8.44596 11.7133 8.44004C11.1021 8.43731 10.4906 8.44323 9.87992 8.43549C9.39632 8.43003 9.06253 8.09715 9.05615 7.63449C9.04978 7.12994 9.3526 6.7916 9.85852 6.78841C11.2641 6.7793 12.6689 6.77824 14.073 6.78522C14.6408 6.78841 14.9605 7.09533 14.971 7.6568C14.9968 9.05055 15.0121 10.4444 15.017 11.8385C15.0188 12.3494 14.6864 12.65 14.1786 12.6459C13.6996 12.6413 13.3845 12.3335 13.3699 11.8371C13.3544 11.2479 13.353 10.6582 13.3444 10.0685C13.3426 9.97556 13.3307 9.88448 13.3203 9.71918Z"
        fill="white"
      />
    </svg>




  );
};
const RedarrowSvg = () => {
  return (
    <svg
      width={22}
      height={22}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="10.8781"
        cy="10.8781"
        r="10.8781"
        transform="rotate(90 10.8781 10.8781)"
        fill="#FF0207"
      />
      <path
        d="M12.0369 13.3203L11.745 13.0284C10.1831 11.4664 8.62102 9.90436 7.05879 8.34213C6.74276 8.0261 6.67355 7.6527 6.84613 7.27975C7.01508 6.92046 7.32427 6.72328 7.69813 6.77565C7.96825 6.8227 8.21789 6.95014 8.41443 7.14132C9.95223 8.65179 11.4704 10.1818 12.9946 11.706L13.2833 11.9947C13.2992 11.9015 13.3101 11.8076 13.3161 11.7133C13.3188 11.1021 13.3129 10.4906 13.3206 9.87992C13.3261 9.39632 13.659 9.06253 14.1216 9.05616C14.6262 9.04978 14.9645 9.3526 14.9677 9.85852C14.9768 11.2641 14.9779 12.6689 14.9709 14.073C14.9677 14.6408 14.6608 14.9605 14.0993 14.971C12.7056 14.9968 11.3117 15.0121 9.91762 15.017C9.40669 15.0188 9.10614 14.6864 9.11024 14.1786C9.1148 13.6996 9.42263 13.3845 9.91898 13.3699C10.5082 13.3544 11.0979 13.353 11.6876 13.3444C11.7805 13.3426 11.8716 13.3307 12.0369 13.3203Z"
        fill="white"
      />
    </svg>

  );
};
const CalendarSvg = () => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33398 1.33398V4.00065"
        stroke="#51627B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.666 1.33398V4.00065"
        stroke="#51627B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6667 2.66699H3.33333C2.59695 2.66699 2 3.26395 2 4.00033V13.3337C2 14.07 2.59695 14.667 3.33333 14.667H12.6667C13.403 14.667 14 14.07 14 13.3337V4.00033C14 3.26395 13.403 2.66699 12.6667 2.66699Z"
        stroke="#51627B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 6.66699H14"
        stroke="#51627B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>



  );
};
const BoxSvg = () => {
  return (
    <svg
      width={17}
      height={17}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.79167 15.3922C8.00703 15.5165 8.25132 15.582 8.5 15.582C8.74868 15.582 8.99297 15.5165 9.20833 15.3922L14.1667 12.5588C14.3818 12.4346 14.5605 12.256 14.6848 12.0409C14.8092 11.8259 14.8747 11.5819 14.875 11.3334V5.66676C14.8747 5.41833 14.8092 5.17433 14.6848 4.95925C14.5605 4.74417 14.3818 4.56556 14.1667 4.44134L9.20833 1.60801C8.99297 1.48367 8.74868 1.41821 8.5 1.41821C8.25132 1.41821 8.00703 1.48367 7.79167 1.60801L2.83333 4.44134C2.61819 4.56556 2.43949 4.74417 2.31516 4.95925C2.19083 5.17433 2.12525 5.41833 2.125 5.66676V11.3334C2.12525 11.5819 2.19083 11.8259 2.31516 12.0409C2.43949 12.256 2.61819 12.4346 2.83333 12.5588L7.79167 15.3922Z"
        stroke="white"
        strokeOpacity="0.75"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 15.5833V8.5"
        stroke="white"
        strokeOpacity="0.75"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.33041 4.95825L8.5 8.49992L14.6696 4.95825"
        stroke="white"
        strokeOpacity="0.75"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.3125 3.02466L11.6875 6.67257"
        stroke="white"
        strokeOpacity="0.75"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
const BoxblackSvg = () => {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25 16.2979C8.47803 16.4296 8.7367 16.4989 9 16.4989C9.2633 16.4989 9.52197 16.4296 9.75 16.2979L15 13.2979C15.2278 13.1664 15.417 12.9773 15.5487 12.7495C15.6803 12.5218 15.7497 12.2635 15.75 12.0004V6.00042C15.7497 5.73737 15.6803 5.47902 15.5487 5.25129C15.417 5.02355 15.2278 4.83444 15 4.70292L9.75 1.70291C9.52197 1.57126 9.2633 1.50195 9 1.50195C8.7367 1.50195 8.47803 1.57126 8.25 1.70291L3 4.70292C2.7722 4.83444 2.58299 5.02355 2.45135 5.25129C2.31971 5.47902 2.25027 5.73737 2.25 6.00042V12.0004C2.25027 12.2635 2.31971 12.5218 2.45135 12.7495C2.58299 12.9773 2.7722 13.1664 3 13.2979L8.25 16.2979Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 16.5V9"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.46753 5.25L9.00003 9L15.5325 5.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.625 3.20215L12.375 7.06465"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

  );
};
const CarriersSvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 13C20 18 16.5 20.5 12.34 21.95C12.1222 22.0238 11.8855 22.0202 11.67 21.94C7.5 20.5 4 18 4 13V5.99996C4 5.73474 4.10536 5.48039 4.29289 5.29285C4.48043 5.10532 4.73478 4.99996 5 4.99996C7 4.99996 9.5 3.79996 11.24 2.27996C11.4519 2.09896 11.7214 1.99951 12 1.99951C12.2786 1.99951 12.5481 2.09896 12.76 2.27996C14.51 3.80996 17 4.99996 19 4.99996C19.2652 4.99996 19.5196 5.10532 19.7071 5.29285C19.8946 5.48039 20 5.73474 20 5.99996V13Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12L11 14L15 10"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

  );
};
const GreyArrowSvg = () => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.3335 8H12.6668"
        stroke="#555555"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 3.3335L12.6667 8.00016L8 12.6668"
        stroke="#555555"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>


  );
};
const SettingWhiteSvg = () => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.14667 1.3335H7.85334C7.49971 1.3335 7.16057 1.47397 6.91053 1.72402C6.66048 1.97407 6.52 2.31321 6.52 2.66683V2.78683C6.51976 3.02065 6.45804 3.25029 6.34103 3.45272C6.22401 3.65515 6.05583 3.82325 5.85333 3.94016L5.56667 4.10683C5.36398 4.22385 5.13405 4.28546 4.9 4.28546C4.66595 4.28546 4.43603 4.22385 4.23333 4.10683L4.13333 4.0535C3.82738 3.877 3.46389 3.82913 3.12267 3.92037C2.78145 4.01161 2.49037 4.23452 2.31333 4.54016L2.16667 4.7935C1.99018 5.09945 1.9423 5.46294 2.03354 5.80416C2.12478 6.14538 2.34769 6.43646 2.65333 6.6135L2.75333 6.68016C2.95485 6.7965 3.12241 6.96355 3.23937 7.16472C3.35632 7.36588 3.4186 7.59414 3.42 7.82683V8.16683C3.42093 8.40178 3.35977 8.6328 3.2427 8.8365C3.12563 9.0402 2.95681 9.20936 2.75333 9.32683L2.65333 9.38683C2.34769 9.56386 2.12478 9.85494 2.03354 10.1962C1.9423 10.5374 1.99018 10.9009 2.16667 11.2068L2.31333 11.4602C2.49037 11.7658 2.78145 11.9887 3.12267 12.08C3.46389 12.1712 3.82738 12.1233 4.13333 11.9468L4.23333 11.8935C4.43603 11.7765 4.66595 11.7149 4.9 11.7149C5.13405 11.7149 5.36398 11.7765 5.56667 11.8935L5.85333 12.0602C6.05583 12.1771 6.22401 12.3452 6.34103 12.5476C6.45804 12.75 6.51976 12.9797 6.52 13.2135V13.3335C6.52 13.6871 6.66048 14.0263 6.91053 14.2763C7.16057 14.5264 7.49971 14.6668 7.85334 14.6668H8.14667C8.50029 14.6668 8.83943 14.5264 9.08948 14.2763C9.33953 14.0263 9.48 13.6871 9.48 13.3335V13.2135C9.48024 12.9797 9.54196 12.75 9.65898 12.5476C9.77599 12.3452 9.94418 12.1771 10.1467 12.0602L10.4333 11.8935C10.636 11.7765 10.866 11.7149 11.1 11.7149C11.3341 11.7149 11.564 11.7765 11.7667 11.8935L11.8667 11.9468C12.1726 12.1233 12.5361 12.1712 12.8773 12.08C13.2186 11.9887 13.5096 11.7658 13.6867 11.4602L13.8333 11.2002C14.0098 10.8942 14.0577 10.5307 13.9665 10.1895C13.8752 9.84827 13.6523 9.5572 13.3467 9.38016L13.2467 9.32683C13.0432 9.20936 12.8744 9.0402 12.7573 8.8365C12.6402 8.6328 12.5791 8.40178 12.58 8.16683V7.8335C12.5791 7.59855 12.6402 7.36753 12.7573 7.16382C12.8744 6.96012 13.0432 6.79097 13.2467 6.6735L13.3467 6.6135C13.6523 6.43646 13.8752 6.14538 13.9665 5.80416C14.0577 5.46294 14.0098 5.09945 13.8333 4.7935L13.6867 4.54016C13.5096 4.23452 13.2186 4.01161 12.8773 3.92037C12.5361 3.82913 12.1726 3.877 11.8667 4.0535L11.7667 4.10683C11.564 4.22385 11.3341 4.28546 11.1 4.28546C10.866 4.28546 10.636 4.22385 10.4333 4.10683L10.1467 3.94016C9.94418 3.82325 9.77599 3.65515 9.65898 3.45272C9.54196 3.25029 9.48024 3.02065 9.48 2.78683V2.66683C9.48 2.31321 9.33953 1.97407 9.08948 1.72402C8.83943 1.47397 8.50029 1.3335 8.14667 1.3335Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>



  );
};
const RightArrowSvg = () => {
  return (
    <svg
      width={17}
      height={17}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.54199 8.5H13.4587"
        stroke="white"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 3.5415L13.4583 8.49984L8.5 13.4582"
        stroke="white"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>




  );
};

const TruckSvg = () => {
  return (
    <svg
      width={28}
      height={28}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.333 20.9998V6.99984C16.333 6.381 16.0872 5.78751 15.6496 5.34992C15.212 4.91234 14.6185 4.6665 13.9997 4.6665H4.66634C4.0475 4.6665 3.45401 4.91234 3.01643 5.34992C2.57884 5.78751 2.33301 6.381 2.33301 6.99984V19.8332C2.33301 20.1426 2.45592 20.4393 2.67472 20.6581C2.89351 20.8769 3.19026 20.9998 3.49967 20.9998H5.83301"
        stroke="#BA0E22"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 21H10.5"
        stroke="#BA0E22"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.1663 21.0002H24.4997C24.8091 21.0002 25.1058 20.8772 25.3246 20.6585C25.5434 20.4397 25.6663 20.1429 25.6663 19.8335V15.5752C25.6659 15.3104 25.5754 15.0537 25.4097 14.8472L21.3497 9.77216C21.2406 9.63552 21.1021 9.52516 20.9446 9.44923C20.7871 9.3733 20.6145 9.33375 20.4397 9.3335H16.333"
        stroke="#BA0E22"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8333 23.3332C21.122 23.3332 22.1667 22.2885 22.1667 20.9998C22.1667 19.7112 21.122 18.6665 19.8333 18.6665C18.5447 18.6665 17.5 19.7112 17.5 20.9998C17.5 22.2885 18.5447 23.3332 19.8333 23.3332Z"
        stroke="#BA0E22"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.16634 23.3332C9.45501 23.3332 10.4997 22.2885 10.4997 20.9998C10.4997 19.7112 9.45501 18.6665 8.16634 18.6665C6.87768 18.6665 5.83301 19.7112 5.83301 20.9998C5.83301 22.2885 6.87768 23.3332 8.16634 23.3332Z"
        stroke="#BA0E22"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

  );
};
const TruckWhiteSvg = () => {
  return (
    <svg
      width={28}
      height={28}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.333 20.9998V6.99984C16.333 6.381 16.0872 5.78751 15.6496 5.34992C15.212 4.91234 14.6185 4.6665 13.9997 4.6665H4.66634C4.0475 4.6665 3.45401 4.91234 3.01643 5.34992C2.57884 5.78751 2.33301 6.381 2.33301 6.99984V19.8332C2.33301 20.1426 2.45592 20.4393 2.67472 20.6581C2.89351 20.8769 3.19026 20.9998 3.49967 20.9998H5.83301"
        stroke="#fff"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 21H10.5"
        stroke="#fff"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.1663 21.0002H24.4997C24.8091 21.0002 25.1058 20.8772 25.3246 20.6585C25.5434 20.4397 25.6663 20.1429 25.6663 19.8335V15.5752C25.6659 15.3104 25.5754 15.0537 25.4097 14.8472L21.3497 9.77216C21.2406 9.63552 21.1021 9.52516 20.9446 9.44923C20.7871 9.3733 20.6145 9.33375 20.4397 9.3335H16.333"
        stroke="#fff"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8333 23.3332C21.122 23.3332 22.1667 22.2885 22.1667 20.9998C22.1667 19.7112 21.122 18.6665 19.8333 18.6665C18.5447 18.6665 17.5 19.7112 17.5 20.9998C17.5 22.2885 18.5447 23.3332 19.8333 23.3332Z"
        stroke="#fff"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.16634 23.3332C9.45501 23.3332 10.4997 22.2885 10.4997 20.9998C10.4997 19.7112 9.45501 18.6665 8.16634 18.6665C6.87768 18.6665 5.83301 19.7112 5.83301 20.9998C5.83301 22.2885 6.87768 23.3332 8.16634 23.3332Z"
        stroke="#fff"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

  );
};
const OceanSvg = () => {
  return (
    <svg
      width={28}
      height={28}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 11.8872V16.3334"
        stroke="#51627B"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 2.3335V5.8335"
        stroke="#51627B"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.1663 15.1668V8.16683C22.1663 7.54799 21.9205 6.9545 21.4829 6.51691C21.0453 6.07933 20.4518 5.8335 19.833 5.8335H8.16634C7.5475 5.8335 6.95401 6.07933 6.51643 6.51691C6.07884 6.9545 5.83301 7.54799 5.83301 8.16683V15.1668"
        stroke="#51627B"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.6098 23.3332C23.8648 21.2152 24.5183 18.795 24.4998 16.3332L14.9472 12.0877C14.6489 11.9552 14.3262 11.8867 13.9998 11.8867C13.6735 11.8867 13.3508 11.9552 13.0525 12.0877L3.49984 16.3332C3.44583 19.6508 4.61251 22.8727 6.77817 25.3865"
        stroke="#51627B"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.33301 24.5002C3.03301 25.0835 3.73301 25.6668 5.24967 25.6668C8.16634 25.6668 8.16634 23.3335 11.083 23.3335C12.5997 23.3335 13.2997 23.9168 13.9997 24.5002C14.6997 25.0835 15.3997 25.6668 16.9163 25.6668C19.833 25.6668 19.833 23.3335 22.7497 23.3335C24.2663 23.3335 24.9663 23.9168 25.6663 24.5002"
        stroke="#51627B"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>


  );
};
const AirSvg = () => {
  return (
    <svg
      width={28}
      height={28}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.7667 22.4L18.6667 12.8333L22.75 8.75C24.5 7 25.0833 4.66667 24.5 3.5C23.3333 2.91667 21 3.5 19.25 5.25L15.1667 9.33333L5.6 7.23333C5.01667 7.11667 4.55 7.35 4.31667 7.81667L3.96667 8.4C3.73333 8.98333 3.85 9.56667 4.31667 9.91667L10.5 14L8.16667 17.5H4.66667L3.5 18.6667L7 21L9.33333 24.5L10.5 23.3333V19.8333L14 17.5L18.0833 23.6833C18.4333 24.15 19.0167 24.2667 19.6 24.0333L20.1833 23.8C20.65 23.45 20.8833 22.9833 20.7667 22.4Z"
        stroke="#51627B"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>



  );
};
const RailSvg = () => {
  return (
    <svg
      width={28}
      height={28}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.0003 3.5H7.00033C5.71166 3.5 4.66699 4.54467 4.66699 5.83333V19.8333C4.66699 21.122 5.71166 22.1667 7.00033 22.1667H21.0003C22.289 22.1667 23.3337 21.122 23.3337 19.8333V5.83333C23.3337 4.54467 22.289 3.5 21.0003 3.5Z"
        stroke="#51627B"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66699 12.8335H23.3337"
        stroke="#51627B"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 3.5V12.8333"
        stroke="#51627B"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33333 22.1665L7 25.6665"
        stroke="#51627B"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.0003 25.6665L18.667 22.1665"
        stroke="#51627B"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33301 17.5H9.34301"
        stroke="#51627B"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.667 17.5H18.677"
        stroke="#51627B"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

  );
};
const DowngreySvg = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5L12 19"
        stroke="#65758B"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 12L12 19L5 12"
        stroke="#65758B"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
const ProgressCheckSvg = () => {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 4.5L6.75 12.75L3 9"
        stroke="white"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

  );
};

const ArrowRightIcon = ({ className }) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M17.92 11.6202C17.8724 11.4974 17.801 11.3853 17.71 11.2902L12.71 6.29019C12.6168 6.19695 12.5061 6.12299 12.3842 6.07253C12.2624 6.02207 12.1319 5.99609 12 5.99609C11.7337 5.99609 11.4783 6.10188 11.29 6.29019C11.1968 6.38342 11.1228 6.49411 11.0723 6.61594C11.0219 6.73776 10.9959 6.86833 10.9959 7.00019C10.9959 7.26649 11.1017 7.52188 11.29 7.71019L14.59 11.0002H7C6.73478 11.0002 6.48043 11.1055 6.29289 11.2931C6.10536 11.4806 6 11.735 6 12.0002C6 12.2654 6.10536 12.5198 6.29289 12.7073C6.48043 12.8948 6.73478 13.0002 7 13.0002H14.59L11.29 16.2902C11.1963 16.3831 11.1219 16.4937 11.0711 16.6156C11.0203 16.7375 10.9942 16.8682 10.9942 17.0002C10.9942 17.1322 11.0203 17.2629 11.0711 17.3848C11.1219 17.5066 11.1963 17.6172 11.29 17.7102C11.383 17.8039 11.4936 17.8783 11.6154 17.9291C11.7373 17.9798 11.868 18.006 12 18.006C12.132 18.006 12.2627 17.9798 12.3846 17.9291C12.5064 17.8783 12.617 17.8039 12.71 17.7102L17.71 12.7102C17.801 12.6151 17.8724 12.5029 17.92 12.3802C18.02 12.1367 18.02 11.8636 17.92 11.6202Z"
      fill="white"
    />
  </svg>
);

const LocationBlackSvg = () => {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 7.5C15 11.2448 10.8457 15.1448 9.45075 16.3493C9.32079 16.447 9.1626 16.4998 9 16.4998C8.8374 16.4998 8.67921 16.447 8.54925 16.3493C7.15425 15.1448 3 11.2448 3 7.5C3 5.9087 3.63214 4.38258 4.75736 3.25736C5.88258 2.13214 7.4087 1.5 9 1.5C10.5913 1.5 12.1174 2.13214 13.2426 3.25736C14.3679 4.38258 15 5.9087 15 7.5Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 9.75C10.2426 9.75 11.25 8.74264 11.25 7.5C11.25 6.25736 10.2426 5.25 9 5.25C7.75736 5.25 6.75 6.25736 6.75 7.5C6.75 8.74264 7.75736 9.75 9 9.75Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>


  );
};
const BuildingSvg = () => {
  return (
    <svg
      width={19}
      height={19}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_113_496)">
        <path
          d="M4.75 17.4163V3.16634C4.75 2.74641 4.91681 2.34369 5.21375 2.04676C5.51068 1.74982 5.91341 1.58301 6.33333 1.58301H12.6667C13.0866 1.58301 13.4893 1.74982 13.7863 2.04676C14.0832 2.34369 14.25 2.74641 14.25 3.16634V17.4163H4.75Z"
          stroke="#51627B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.75065 9.5H3.16732C2.74739 9.5 2.34466 9.66682 2.04773 9.96375C1.7508 10.2607 1.58398 10.6634 1.58398 11.0833V15.8333C1.58398 16.2533 1.7508 16.656 2.04773 16.9529C2.34466 17.2499 2.74739 17.4167 3.16732 17.4167H4.75065"
          stroke="#51627B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.25 7.125H15.8333C16.2533 7.125 16.656 7.29182 16.9529 7.58875C17.2499 7.88568 17.4167 8.28841 17.4167 8.70833V15.8333C17.4167 16.2533 17.2499 16.656 16.9529 16.9529C16.656 17.2499 16.2533 17.4167 15.8333 17.4167H14.25"
          stroke="#51627B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.91602 4.75H11.0827"
          stroke="#51627B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.91602 7.91602H11.0827"
          stroke="#51627B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.91602 11.084H11.0827"
          stroke="#51627B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.91602 14.25H11.0827"
          stroke="#51627B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_113_496">
          <rect width={19} height={19} fill="white" />
        </clipPath>
      </defs>
    </svg>



  );
};
const Wallet2Svg = () => {
  return (
    <svg
      width={17}
      height={17}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.166 3.54102H2.83268C2.05028 3.54102 1.41602 4.17528 1.41602 4.95768V12.041C1.41602 12.8234 2.05028 13.4577 2.83268 13.4577H14.166C14.9484 13.4577 15.5827 12.8234 15.5827 12.041V4.95768C15.5827 4.17528 14.9484 3.54102 14.166 3.54102Z"
        stroke="#51627B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.41602 7.08398H15.5827"
        stroke="#51627B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>




  );
};
const VahicalSvg = () => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33398 11.9993V3.99935C9.33398 3.64573 9.19351 3.30659 8.94346 3.05654C8.69341 2.80649 8.35427 2.66602 8.00065 2.66602H2.66732C2.3137 2.66602 1.97456 2.80649 1.72451 3.05654C1.47446 3.30659 1.33398 3.64573 1.33398 3.99935V11.3327C1.33398 11.5095 1.40422 11.6791 1.52925 11.8041C1.65427 11.9291 1.82384 11.9993 2.00065 11.9993H3.33398"
        stroke="#51627B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 12H6"
        stroke="#51627B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6673 12.0007H14.0007C14.1775 12.0007 14.347 11.9304 14.4721 11.8054C14.5971 11.6804 14.6673 11.5108 14.6673 11.334V8.90065C14.667 8.74936 14.6153 8.60266 14.5207 8.48465L12.2007 5.58465C12.1383 5.50657 12.0592 5.44351 11.9692 5.40012C11.8792 5.35673 11.7806 5.33413 11.6807 5.33398H9.33398"
        stroke="#51627B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3333 13.3337C12.0697 13.3337 12.6667 12.7367 12.6667 12.0003C12.6667 11.2639 12.0697 10.667 11.3333 10.667C10.597 10.667 10 11.2639 10 12.0003C10 12.7367 10.597 13.3337 11.3333 13.3337Z"
        stroke="#51627B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66732 13.3327C5.4037 13.3327 6.00065 12.7357 6.00065 11.9993C6.00065 11.263 5.4037 10.666 4.66732 10.666C3.93094 10.666 3.33398 11.263 3.33398 11.9993C3.33398 12.7357 3.93094 13.3327 4.66732 13.3327Z"
        stroke="#51627B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>





  );
};
const ProfileEditSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.57675 2.32422H6.46091C3.89841 2.32422 2.29175 4.13839 2.29175 6.70672V13.6351C2.29175 16.2034 3.89091 18.0176 6.46091 18.0176H13.8142C16.3851 18.0176 17.9842 16.2034 17.9842 13.6351V10.2784"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.35652 9.10074L13.584 2.87324C14.3599 2.09824 15.6174 2.09824 16.3932 2.87324L17.4074 3.88741C18.1832 4.66324 18.1832 5.92158 17.4074 6.69658L11.1499 12.9541C10.8107 13.2932 10.3507 13.4841 9.87069 13.4841H6.74902L6.82736 10.3341C6.83902 9.87074 7.02819 9.42908 7.35652 9.10074Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6377 3.83545L16.4427 7.64045"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>

  );
};
const VerifiedSvg = () => {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_235_1689)">
        <path
          d="M2.88789 6.46483C2.77842 5.97172 2.79523 5.45896 2.93676 4.97408C3.07828 4.48921 3.33995 4.04791 3.69749 3.69112C4.05503 3.33433 4.49687 3.07359 4.98204 2.93307C5.46722 2.79256 5.98001 2.77683 6.47289 2.88733C6.74417 2.46305 7.11789 2.1139 7.5596 1.87204C8.00131 1.63019 8.4968 1.50342 9.00039 1.50342C9.50398 1.50342 9.99946 1.63019 10.4412 1.87204C10.8829 2.1139 11.2566 2.46305 11.5279 2.88733C12.0215 2.77635 12.5352 2.79201 13.0211 2.93286C13.5071 3.07372 13.9495 3.33518 14.3073 3.69294C14.665 4.0507 14.9265 4.49313 15.0674 4.97908C15.2082 5.46503 15.2239 5.9787 15.1129 6.47233C15.5372 6.74361 15.8863 7.11733 16.1282 7.55904C16.37 8.00075 16.4968 8.49624 16.4968 8.99983C16.4968 9.50342 16.37 9.9989 16.1282 10.4406C15.8863 10.8823 15.5372 11.256 15.1129 11.5273C15.2234 12.0202 15.2077 12.533 15.0671 13.0182C14.9266 13.5033 14.6659 13.9452 14.3091 14.3027C13.9523 14.6603 13.511 14.9219 13.0261 15.0635C12.5413 15.205 12.0285 15.2218 11.5354 15.1123C11.2645 15.5382 10.8904 15.8889 10.448 16.1318C10.0055 16.3748 9.50891 16.5021 9.00414 16.5021C8.49937 16.5021 8.00276 16.3748 7.56029 16.1318C7.11783 15.8889 6.74382 15.5382 6.47289 15.1123C5.98001 15.2228 5.46722 15.2071 4.98204 15.0666C4.49687 14.9261 4.05503 14.6653 3.69749 14.3085C3.33995 13.9517 3.07828 13.5104 2.93676 13.0256C2.79523 12.5407 2.77842 12.0279 2.88789 11.5348C2.46036 11.2643 2.1082 10.89 1.86418 10.4467C1.62015 10.0035 1.49219 9.50578 1.49219 8.99983C1.49219 8.49387 1.62015 7.99614 1.86418 7.55292C2.1082 7.1097 2.46036 6.7354 2.88789 6.46483Z"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.75 9L8.25 10.5L11.25 7.5"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_235_1689">
          <rect width={18} height={18} fill="white" />
        </clipPath>
      </defs>
    </svg>



  );
};
const MailSvg = () => {
  return (
    <svg
      width={21}
      height={21}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3048 11.7818C9.71939 11.7818 9.13576 11.5884 8.64751 11.2017L4.72314 8.03768C4.44051 7.81018 4.39676 7.3963 4.62339 7.11455C4.85176 6.83368 5.26476 6.78905 5.54651 7.01568L9.46739 10.1762C9.96001 10.5664 10.6539 10.5664 11.15 10.1727L15.0315 7.01743C15.3133 6.7873 15.7263 6.83105 15.9555 7.1128C16.1839 7.39368 16.141 7.80668 15.8601 8.03593L11.9716 11.1964C11.4799 11.5867 10.8919 11.7818 10.3048 11.7818Z"
        fill="black"
      />
      <mask
        id="mask0_239_1739"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={1}
        width={20}
        height={18}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.875 1.75H19.6874V18.8125H0.875V1.75Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_239_1739)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.98413 17.5H14.5766C14.5784 17.4983 14.5854 17.5 14.5906 17.5C15.589 17.5 16.4745 17.143 17.1535 16.4649C17.9419 15.68 18.375 14.5521 18.375 13.2895V7.28C18.375 4.83613 16.7773 3.0625 14.5766 3.0625H5.98588C3.78525 3.0625 2.1875 4.83613 2.1875 7.28V13.2895C2.1875 14.5521 2.6215 15.68 3.409 16.4649C4.088 17.143 4.97437 17.5 5.97187 17.5H5.98413ZM5.96925 18.8125C4.61913 18.8125 3.41337 18.3225 2.48238 17.395C1.4455 16.3607 0.875 14.903 0.875 13.2895V7.28C0.875 4.12738 3.07213 1.75 5.98588 1.75H14.5766C17.4904 1.75 19.6875 4.12738 19.6875 7.28V13.2895C19.6875 14.903 19.117 16.3607 18.0801 17.395C17.15 18.3216 15.9434 18.8125 14.5906 18.8125H14.5766H5.98588H5.96925Z"
          fill="black"
        />
      </g>
    </svg>



  );
};
const PhoneBlackSvg = () => {
  return (
    <svg
      width={21}
      height={21}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_239_1729"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x={12}
        y={1}
        width={9}
        height={9}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5586 1.75049H20.0302V9.2167H12.5586V1.75049Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_239_1729)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.3737 9.2167C19.0438 9.2167 18.7603 8.96908 18.7227 8.63395C18.3911 5.67995 16.0968 3.38745 13.142 3.05933C12.7823 3.01908 12.5225 2.69533 12.5627 2.33483C12.6021 1.9752 12.9232 1.71008 13.2872 1.75558C16.8555 2.15195 19.6266 4.91957 20.0265 8.48695C20.0667 8.84745 19.8077 9.17208 19.4481 9.21233C19.4236 9.21495 19.3982 9.2167 19.3737 9.2167Z"
          fill="black"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2764 9.22626C15.9684 9.22626 15.6945 9.00926 15.6333 8.69601C15.3813 7.40101 14.3829 6.40263 13.0897 6.15151C12.7335 6.08238 12.5017 5.73851 12.5708 5.38238C12.6399 5.02626 12.9899 4.79351 13.3399 4.86351C15.1608 5.21701 16.5669 6.62226 16.9213 8.44401C16.9904 8.80101 16.7585 9.14488 16.4033 9.21401C16.3604 9.22188 16.3184 9.22626 16.2764 9.22626Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.94131 3.51055C4.62772 1.82399 5.7256 1.37684 6.89736 2.05059C7.23442 2.24441 7.55069 2.51556 7.98037 2.95195L9.29873 4.31914C10.0264 5.11337 10.1919 5.87521 9.95498 6.76738L9.92177 6.88555L9.88564 7.00371L9.70986 7.52031C9.33276 8.67962 9.49015 9.33415 10.8319 10.6756C12.2271 12.0704 12.8791 12.1842 14.1278 11.7479L14.3495 11.6707L14.619 11.5828L14.7372 11.5506C15.6856 11.2976 16.4871 11.4993 17.3368 12.3484L18.3983 13.3748L18.7108 13.6814C19.0574 14.0348 19.2868 14.3152 19.456 14.6111C20.1256 15.7826 19.6783 16.8806 17.9433 18.6092L17.7782 18.7762C17.5191 19.0258 17.2764 19.205 16.9208 19.3738C16.324 19.6571 15.6189 19.7641 14.7997 19.6502C12.7807 19.3694 10.2202 17.7759 6.97548 14.532C6.71136 14.268 6.45778 14.0096 6.21572 13.7557L5.74599 13.2537C1.34537 8.47245 0.95732 5.53534 2.76064 3.69316L2.87783 3.57695L2.94131 3.51055ZM6.24306 3.18828C5.83928 2.95619 5.40339 3.05441 4.59658 3.74883L4.34267 3.97539C4.29853 4.01614 4.25313 4.05846 4.20693 4.10234L3.91689 4.38555L3.89052 4.41875L3.69326 4.61602C3.21699 5.10249 2.9911 5.69656 3.18545 6.71758C3.50448 8.39322 4.96498 10.6668 7.90322 13.6043C10.9646 16.6648 13.2972 18.1162 14.9804 18.3504C15.9614 18.4868 16.4622 18.249 16.9726 17.7264L17.3622 17.3328C17.5446 17.1419 17.7003 16.9684 17.8319 16.8104L18.0116 16.5848C18.4707 15.9733 18.5126 15.606 18.3163 15.2625C18.2416 15.1319 18.1326 14.9883 17.9745 14.8133L17.7606 14.5867L17.6337 14.4598L16.2938 13.1658C15.8461 12.7529 15.5396 12.6942 15.0751 12.8182L14.9413 12.8572L14.3856 13.0457C12.7758 13.5655 11.6145 13.3131 9.9042 11.6033C8.13263 9.83221 7.92487 8.64902 8.51845 6.94609L8.55654 6.83672L8.66201 6.52031L8.71377 6.31816C8.80555 5.87808 8.70049 5.57061 8.22744 5.09746C8.20795 5.07798 8.1857 5.05606 8.16201 5.03203L6.91787 3.7459C6.6328 3.46486 6.42563 3.29326 6.24306 3.18828Z"
        fill="black"
      />
    </svg>

  );
};
const GrowthSvg = () => {
  return (
    <svg
      width={15}
      height={15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.75 4.375L8.4375 9.6875L5.3125 6.5625L1.25 10.625"
        stroke="#119F0E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 4.375H13.75V8.125"
        stroke="#119F0E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>




  );
};

const BellIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 17.8476C17.6392 17.8476 20.2481 17.1242 20.5 14.2205C20.5 11.3188 18.6812 11.5054 18.6812 7.94511C18.6812 5.16414 16.0452 2 12 2C7.95477 2 5.31885 5.16414 5.31885 7.94511C5.31885 11.5054 3.5 11.3188 3.5 14.2205C3.75295 17.1352 6.36177 17.8476 12 17.8476Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3887 20.8574C13.0246 22.3721 10.8966 22.3901 9.51941 20.8574"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const EditIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7161 16.2236H8.49609"
        stroke="#162159"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7161 12.0371H8.49609"
        stroke="#162159"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2511 7.86035H8.49609"
        stroke="#162159"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9085 2.75C15.9085 2.75 8.23149 2.754 8.21949 2.754C5.45949 2.771 3.75049 4.587 3.75049 7.357V16.553C3.75049 19.337 5.47249 21.16 8.25649 21.16C8.25649 21.16 15.9325 21.157 15.9455 21.157C18.7055 21.14 20.4155 19.323 20.4155 16.553V7.357C20.4155 4.573 18.6925 2.75 15.9085 2.75Z"
        stroke="#162159"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};


const DeleteIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7476 20.4428H21.0002"
        stroke="#CA0D16"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.78 3.79479C13.5557 2.86779 14.95 2.73186 15.8962 3.49173C15.9485 3.53296 17.6295 4.83879 17.6295 4.83879C18.669 5.46719 18.992 6.80311 18.3494 7.82259C18.3153 7.87718 8.81195 19.7645 8.81195 19.7645C8.49578 20.1589 8.01583 20.3918 7.50291 20.3973L3.86353 20.443L3.04353 16.9723C2.92866 16.4843 3.04353 15.9718 3.3597 15.5773L12.78 3.79479Z"
        stroke="#CA0D16"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.021 6.00098L16.4732 10.1881"
        stroke="#CA0D16"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const MyAccountIcon = () => {
  return (
    <svg
      width={21}
      height={21}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4871 13.4287C7.10289 13.4287 4.21289 13.9404 4.21289 15.9895C4.21289 18.0387 7.08456 18.5687 10.4871 18.5687C13.8712 18.5687 16.7604 18.0562 16.7604 16.0079C16.7604 13.9595 13.8896 13.4287 10.4871 13.4287Z"
        stroke="#454545"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4865 10.5054C12.7074 10.5054 14.5074 8.70456 14.5074 6.48372C14.5074 4.26289 12.7074 2.46289 10.4865 2.46289C8.2657 2.46289 6.46487 4.26289 6.46487 6.48372C6.45737 8.69706 8.2457 10.4979 10.4582 10.5054H10.4865Z"
        stroke="#454545"
        strokeWidth="1.42857"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const SettingsIcon = () => {
  return (
    <svg
      width={21}
      height={21}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2062 6.67051L17.6616 5.72543C17.2008 4.92575 16.1798 4.64988 15.379 5.10872V5.10872C14.9978 5.33327 14.543 5.39698 14.1148 5.2858C13.6866 5.17462 13.3202 4.89767 13.0964 4.51605C12.9524 4.27348 12.8751 3.99719 12.8721 3.71513V3.71513C12.8851 3.26292 12.7145 2.8247 12.3992 2.50031C12.0838 2.17592 11.6506 1.99298 11.1982 1.99316H10.101C9.65774 1.99316 9.2328 2.16977 8.92015 2.48392C8.6075 2.79808 8.43292 3.22387 8.43506 3.66708V3.66708C8.42192 4.58216 7.67632 5.31706 6.76114 5.31696C6.47908 5.31403 6.2028 5.23667 5.96023 5.09271V5.09271C5.15945 4.63386 4.13837 4.90973 3.67762 5.70941L3.09295 6.67051C2.63276 7.46919 2.90487 8.48963 3.70165 8.95312V8.95312C4.21956 9.25213 4.53861 9.80474 4.53861 10.4028C4.53861 11.0008 4.21956 11.5534 3.70165 11.8524V11.8524C2.90588 12.3128 2.63347 13.3308 3.09295 14.127V14.127L3.64558 15.0801C3.86146 15.4697 4.22367 15.7571 4.65207 15.8789C5.08046 16.0006 5.53971 15.9466 5.92819 15.7289V15.7289C6.31009 15.506 6.76519 15.445 7.19232 15.5593C7.61945 15.6736 7.98323 15.9538 8.20279 16.3376C8.34676 16.5801 8.42412 16.8564 8.42705 17.1385V17.1385C8.42705 18.063 9.17648 18.8124 10.101 18.8124H11.1982C12.1196 18.8124 12.8677 18.0678 12.8721 17.1465V17.1465C12.87 16.7019 13.0457 16.2749 13.36 15.9605C13.6744 15.6461 14.1014 15.4704 14.546 15.4726C14.8274 15.4801 15.1026 15.5571 15.347 15.6968V15.6968C16.1456 16.157 17.1661 15.8849 17.6296 15.0881V15.0881L18.2062 14.127C18.4294 13.7439 18.4907 13.2876 18.3764 12.8592C18.2622 12.4307 17.9819 12.0655 17.5975 11.8444V11.8444C17.2132 11.6233 16.9329 11.2581 16.8186 10.8297C16.7044 10.4012 16.7656 9.94494 16.9888 9.56181C17.134 9.30839 17.3441 9.09827 17.5975 8.95312V8.95312C18.3895 8.48988 18.661 7.4754 18.2062 6.67852V6.67852V6.67051Z"
        stroke="#454545"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="10.6543"
        cy="10.4023"
        r="2.30664"
        stroke="#454545"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const BankIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3C10.6868 3 9.38642 3.25866 8.17317 3.7612C6.95991 4.26375 5.85752 5.00035 4.92893 5.92893C4.00035 6.85752 3.26375 7.95991 2.7612 9.17317C2.25866 10.3864 2 11.6868 2 13C2 14.3132 2.25866 15.6136 2.7612 16.8268C3.26375 18.0401 4.00035 19.1425 4.92893 20.0711C5.85752 20.9997 6.95991 21.7363 8.17317 22.2388C9.38642 22.7413 10.6868 23 12 23C13.3132 23 14.6136 22.7413 15.8268 22.2388C17.0401 21.7363 18.1425 20.9997 19.0711 20.0711C19.9997 19.1425 20.7363 18.0401 21.2388 16.8268C21.7413 15.6136 22 14.3132 22 13C22 11.6868 21.7413 10.3864 21.2388 9.17317C20.7363 7.95991 19.9997 6.85752 19.0711 5.92893C18.1425 5.00035 17.0401 4.26375 15.8268 3.7612C14.6136 3.25866 13.3132 3 12 3Z"
        stroke="#454545"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="13" r="2.5" stroke="#454545" strokeWidth="1.5" />
      <path
        d="M12 8V10"
        stroke="#454545"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12 16V18"
        stroke="#454545"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

const HelpIcon = () => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.29 15.29C11.247 15.3375 11.2069 15.3876 11.17 15.44C11.1322 15.4957 11.1019 15.5563 11.08 15.62C11.0512 15.6767 11.031 15.7374 11.02 15.8C11.0151 15.8666 11.0151 15.9334 11.02 16C11.0166 16.1312 11.044 16.2613 11.1 16.38C11.1449 16.5041 11.2166 16.6168 11.3099 16.7101C11.4032 16.8034 11.5159 16.8751 11.64 16.92C11.7597 16.9729 11.8891 17.0002 12.02 17.0002C12.1509 17.0002 12.2803 16.9729 12.4 16.92C12.5241 16.8751 12.6368 16.8034 12.7301 16.7101C12.8234 16.6168 12.8951 16.5041 12.94 16.38C12.9844 16.2584 13.0048 16.1294 13 16C13.0008 15.8684 12.9755 15.7379 12.9258 15.6161C12.876 15.4943 12.8027 15.3834 12.71 15.29C12.617 15.1963 12.5064 15.1219 12.3846 15.0711C12.2627 15.0203 12.132 14.9942 12 14.9942C11.868 14.9942 11.7373 15.0203 11.6154 15.0711C11.4936 15.1219 11.383 15.1963 11.29 15.29ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM12 20C10.4178 20 8.87104 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00346 15.0615 4.60896C16.5233 5.21447 17.7727 6.23984 18.6518 7.55544C19.5308 8.87103 20 10.4177 20 12C20 14.1217 19.1572 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20ZM12 7C11.4731 6.99966 10.9553 7.13812 10.4989 7.40144C10.0425 7.66476 9.66347 8.04366 9.4 8.5C9.32765 8.61382 9.27907 8.7411 9.25718 8.87418C9.23529 9.00726 9.24055 9.14339 9.27263 9.27439C9.30472 9.40538 9.36297 9.52854 9.44389 9.63643C9.52481 9.74433 9.62671 9.83475 9.74348 9.90224C9.86024 9.96974 9.98945 10.0129 10.1233 10.0292C10.2572 10.0454 10.393 10.0345 10.5225 9.99688C10.6521 9.9593 10.7727 9.89591 10.8771 9.81052C10.9814 9.72513 11.0675 9.6195 11.13 9.5C11.2181 9.3474 11.345 9.22078 11.4978 9.13298C11.6505 9.04518 11.8238 8.9993 12 9C12.2652 9 12.5196 9.10536 12.7071 9.29289C12.8946 9.48043 13 9.73478 13 10C13 10.2652 12.8946 10.5196 12.7071 10.7071C12.5196 10.8946 12.2652 11 12 11C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12V13C11 13.2652 11.1054 13.5196 11.2929 13.7071C11.4804 13.8946 11.7348 14 12 14C12.2652 14 12.5196 13.8946 12.7071 13.7071C12.8946 13.5196 13 13.2652 13 13V12.82C13.6614 12.58 14.2174 12.1152 14.5708 11.5069C14.9242 10.8985 15.0525 10.1853 14.9334 9.49189C14.8143 8.79849 14.4552 8.16902 13.919 7.71352C13.3828 7.25801 12.7035 7.00546 12 7Z"
        fill="#5C5C5C"
      />
    </svg>
  );
};

export const DashBoardSvg = () => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5 16.6667C17.5 16.8877 17.4122 17.0996 17.2559 17.2559C17.0996 17.4122 16.8877 17.5 16.6667 17.5H3.33333C3.11232 17.5 2.90036 17.4122 2.74408 17.2559C2.5878 17.0996 2.5 16.8877 2.5 16.6667V7.76166C2.49995 7.63578 2.52842 7.51153 2.58326 7.39823C2.63811 7.28493 2.71791 7.18553 2.81667 7.10749L9.48333 1.84832C9.63046 1.73206 9.81249 1.66882 10 1.66882C10.1875 1.66882 10.3695 1.73206 10.5167 1.84832L17.1833 7.10666C17.2822 7.18478 17.3621 7.28432 17.4169 7.39777C17.4718 7.51123 17.5002 7.63564 17.5 7.76166V16.6667ZM5.83333 9.99999C5.83333 11.1051 6.27232 12.1649 7.05372 12.9463C7.83512 13.7277 8.89493 14.1667 10 14.1667C11.1051 14.1667 12.1649 13.7277 12.9463 12.9463C13.7277 12.1649 14.1667 11.1051 14.1667 9.99999H12.5C12.5 10.663 12.2366 11.2989 11.7678 11.7678C11.2989 12.2366 10.663 12.5 10 12.5C9.33696 12.5 8.70107 12.2366 8.23223 11.7678C7.76339 11.2989 7.5 10.663 7.5 9.99999H5.83333Z"
        fill="#fff"
      />
    </svg>
  )
}

export const UsersSvg = () => {
  return (
    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="User / Users">
        <path id="Vector" d="M21 19.9999C21 18.2583 19.3304 16.7767 17 16.2275M15 20C15 17.7909 12.3137 16 9 16C5.68629 16 3 17.7909 3 20M15 13C17.2091 13 19 11.2091 19 9C19 6.79086 17.2091 5 15 5M9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9C13 11.2091 11.2091 13 9 13Z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </g>
    </svg>
  )
}
export const AdminSvg = () => {
  return (
    <svg fill="#fff" height="20px" width="20px" version="1.1" xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24" enable-background="new 0 0 24 24">
      <g id="user-admin">
        <path d="M22.3,16.7l1.4-1.4L20,11.6l-5.8,5.8c-0.5-0.3-1.1-0.4-1.7-0.4C10.6,17,9,18.6,9,20.5s1.6,3.5,3.5,3.5s3.5-1.6,3.5-3.5
		c0-0.6-0.2-1.2-0.4-1.7l1.9-1.9l2.3,2.3l1.4-1.4l-2.3-2.3l1.1-1.1L22.3,16.7z M12.5,22c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5
		s1.5,0.7,1.5,1.5S13.3,22,12.5,22z"/>
        <path d="M2,19c0-3.9,3.1-7,7-7c2,0,3.9,0.9,5.3,2.4l1.5-1.3c-0.9-1-1.9-1.8-3.1-2.3C14.1,9.7,15,7.9,15,6c0-3.3-2.7-6-6-6
		S3,2.7,3,6c0,1.9,0.9,3.7,2.4,4.8C2.2,12.2,0,15.3,0,19v5h8v-2H2V19z M5,6c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4S5,8.2,5,6z"/>
      </g>
    </svg>
  )
}
export const AccessControlSvg = () => {
  return (
    <svg fill="#fff" height="20px" width="20px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 208.752 208.752">
      <g>
        <path d="M192.042,116.167c1.19-6.058,1.82-12.314,1.82-18.715c0-53.448-43.483-96.931-96.931-96.931S0,44.005,0,97.453
		c0,53.448,43.483,96.931,96.931,96.931c7.004,0,13.834-0.753,20.42-2.171c9.687,9.876,23.167,16.018,38.06,16.018
		c29.413,0,53.342-23.929,53.342-53.342C208.752,139.651,202.32,125.897,192.042,116.167z M155.41,196.23
		c-22.796,0-41.342-18.546-41.342-41.342c0-22.796,18.546-41.342,41.342-41.342s41.342,18.546,41.342,41.342
		C196.752,177.684,178.206,196.23,155.41,196.23z M12.236,103.453h30.216c0.587,11.055,2.748,21.815,6.348,32H21.009
		C16.109,125.702,13.038,114.888,12.236,103.453z M21.009,59.453h28c-3.716,10.287-5.96,21.073-6.558,32H12.236
		C13.038,80.017,16.109,69.203,21.009,59.453z M96.977,14.32c12.374,8.88,22.409,20.23,29.628,33.132H67.67
		C74.923,34.617,84.881,23.209,96.977,14.32z M132.324,59.453c4.025,10.095,6.455,20.88,7.089,32H54.46
		c0.673-10.983,3.217-21.802,7.385-32H132.324z M181.626,91.453h-30.204c-0.563-11.048-2.701-21.808-6.279-32h27.709
		C177.752,69.203,180.823,80.017,181.626,91.453z M54.46,103.453h84.932c-0.012,0.19-0.031,0.379-0.044,0.569
		c-15.372,4.865-27.742,16.523-33.598,31.431H61.631C57.579,125.365,55.121,114.581,54.46,103.453z M102.598,147.453
		c-0.341,2.432-0.529,4.911-0.529,7.436c0,6.651,1.234,13.016,3.468,18.893c-2.634,2.407-5.391,4.69-8.278,6.815
		c-12.47-8.864-22.585-20.217-29.867-33.144H102.598z M169.514,103.453h12.112c-0.112,1.592-0.268,3.171-0.467,4.739
		C177.516,106.174,173.612,104.578,169.514,103.453z M165.524,47.453h-25.389c-5.901-12.153-13.954-23.231-23.868-32.684
		C136.353,19.466,153.716,31.298,165.524,47.453z M78.028,14.669c-9.834,9.502-17.925,20.652-23.905,32.784H28.337
		C40.23,31.182,57.758,19.296,78.028,14.669z M28.337,147.453h25.505c5.959,12.199,14.094,23.306,24.106,32.766
		C57.711,175.578,40.214,163.702,28.337,147.453z"/>
        <path d="M161.626,155.831c2.105-1.777,3.472-4.402,3.472-7.374c0-5.35-4.337-9.688-9.688-9.688s-9.688,4.338-9.688,9.688
		c0,2.971,1.367,5.597,3.472,7.374l-4.807,15.177h22.045L161.626,155.831z"/>
      </g>
    </svg>
  )
}

export const ModulesSvg = () => {
  return (
    <svg fill="#fff" width="20px" height="20px" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">
      <path d="M1581.176 1072.47h-225.882v438.551l-366.833 213.685c-17.506 10.278-39.416 10.278-56.922 0L564.706 1511.02v-438.55H338.824V685.647c0-20.103 10.842-38.739 28.009-48.79l310.814-181.045v164.894h564.706V455.812l310.814 181.044c17.167 10.052 28.01 28.688 28.01 48.791v386.824Zm112.942 0V685.648c0-60.085-32.189-116.216-84.142-146.485L1242.353 325.14V56H677.647v269.139L310.024 539.162c-51.953 30.269-84.142 86.4-84.142 146.485v386.824H0v564.705h557.026l317.703 185.111c26.429 15.36 55.68 23.04 85.271 23.04 29.59 0 58.955-7.68 85.27-23.04l317.704-185.11H1920V1072.47h-225.882Z" fill-rule="evenodd" />
    </svg>
  )
}


export const PermissionSvg = () => {
  return (
    <svg fill="#fff" width="20px" height="20px" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">
      <path d="M1707 1760c0 29.44-23.893 53.333-53.333 53.333h-320c-29.44 0-53.334-23.893-53.334-53.333v-266.667H1707V1760ZM213.667 1484.053V1337.6c0-86.613 56.426-162.133 140.48-187.947 182.826-56 373.12-82.24 562.346-82.986 146.88.746 292.8 19.413 436.267 54.4-44.053 39.04-72.427 95.466-72.427 158.933v106.667h-106.666v288.32c-87.467 20.266-176.96 31.68-266.667 31.68-144.427 0-423.467-29.334-693.333-222.614ZM1387 1280c0-58.773 47.893-106.667 106.667-106.667 58.773 0 106.666 47.894 106.666 106.667v106.667H1387V1280ZM899.533 106.667h14.934c174.08 0 322.346 122.56 357.653 290.24-30.187 17.493-61.44 29.76-115.52 29.76-69.547 0-101.12-19.947-141.227-45.227-45.653-28.8-97.28-61.44-196.906-61.44-100.374 0-152.32 32.747-198.187 61.653-26.773 16.96-49.813 31.467-82.987 39.147 25.28-177.28 178.134-314.133 362.24-314.133Zm807.467 1280V1280c0-61.653-26.667-116.8-68.587-155.733l.107-.107c-37.867-43.733-123.093-69.76-146.88-76.267-100.373-30.826-202.88-53.013-306.453-67.626C1306.893 894.72 1387 753.813 1387 594.133h-106.667c0 201.707-164.16 365.867-365.866 365.867h-14.934c-201.706 0-365.866-164.16-365.866-365.867v-64.32c66.24-9.173 106.88-34.773 143.573-57.92 40.107-25.28 71.787-45.226 141.227-45.226 68.693 0 100.16 19.84 139.946 45.013 45.867 28.907 97.814 61.653 198.187 61.653 100.373 0 152.533-33.066 202.453-64.746l28.267-18.027-3.84-33.28C1355.427 179.413 1153.72 0 914.467 0h-14.934C638.947 0 427 211.947 427 480v114.133c0 159.787 80.107 300.694 201.92 386.24-103.36 14.507-205.653 36.587-306.133 67.307C193.72 1087.36 107 1203.84 107 1337.6v200.213l21.333 15.894C429.453 1779.627 745.4 1813.333 907 1813.333c90.453 0 180.48-11.52 268.907-30.506 11.306 77.333 77.333 137.173 157.76 137.173h320c88.213 0 160-71.787 160-160v-373.333H1707Z" fill-rule="evenodd" />
    </svg>
  )
}


export const RolesSvg = () => {
  return (
    <svg fill="#fff" width="20px" height="20px" viewBox="0 0 52 52" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg">
      <path d="M38.3,27.2A11.4,11.4,0,1,0,49.7,38.6,11.46,11.46,0,0,0,38.3,27.2Zm2,12.4a2.39,2.39,0,0,1-.9-.2l-4.3,4.3a1.39,1.39,0,0,1-.9.4,1,1,0,0,1-.9-.4,1.39,1.39,0,0,1,0-1.9l4.3-4.3a2.92,2.92,0,0,1-.2-.9,3.47,3.47,0,0,1,3.4-3.8,2.39,2.39,0,0,1,.9.2c.2,0,.2.2.1.3l-2,1.9a.28.28,0,0,0,0,.5L41.1,37a.38.38,0,0,0,.6,0l1.9-1.9c.1-.1.4-.1.4.1a3.71,3.71,0,0,1,.2.9A3.57,3.57,0,0,1,40.3,39.6Z" />
      <circle cx="21.7" cy="14.9" r="12.9" />
      <path d="M25.2,49.8c2.2,0,1-1.5,1-1.5h0a15.44,15.44,0,0,1-3.4-9.7,15,15,0,0,1,1.4-6.4.77.77,0,0,1,.2-.3c.7-1.4-.7-1.5-.7-1.5h0a12.1,12.1,0,0,0-1.9-.1A19.69,19.69,0,0,0,2.4,47.1c0,1,.3,2.8,3.4,2.8H24.9C25.1,49.8,25.1,49.8,25.2,49.8Z" />
    </svg>
  )
}

export const ManageUserSvg = () => {
  return (
    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.5 7.5C15.5 9.433 13.933 11 12 11C10.067 11 8.5 9.433 8.5 7.5C8.5 5.567 10.067 4 12 4C13.933 4 15.5 5.567 15.5 7.5Z" fill="#fff" />
      <path d="M18 16.5C18 18.433 15.3137 20 12 20C8.68629 20 6 18.433 6 16.5C6 14.567 8.68629 13 12 13C15.3137 13 18 14.567 18 16.5Z" fill="#fff" />
      <path d="M7.12205 5C7.29951 5 7.47276 5.01741 7.64005 5.05056C7.23249 5.77446 7 6.61008 7 7.5C7 8.36825 7.22131 9.18482 7.61059 9.89636C7.45245 9.92583 7.28912 9.94126 7.12205 9.94126C5.70763 9.94126 4.56102 8.83512 4.56102 7.47063C4.56102 6.10614 5.70763 5 7.12205 5Z" fill="#fff" />
      <path d="M5.44734 18.986C4.87942 18.3071 4.5 17.474 4.5 16.5C4.5 15.5558 4.85657 14.744 5.39578 14.0767C3.4911 14.2245 2 15.2662 2 16.5294C2 17.8044 3.5173 18.8538 5.44734 18.986Z" fill="#fff" />
      <path d="M16.9999 7.5C16.9999 8.36825 16.7786 9.18482 16.3893 9.89636C16.5475 9.92583 16.7108 9.94126 16.8779 9.94126C18.2923 9.94126 19.4389 8.83512 19.4389 7.47063C19.4389 6.10614 18.2923 5 16.8779 5C16.7004 5 16.5272 5.01741 16.3599 5.05056C16.7674 5.77446 16.9999 6.61008 16.9999 7.5Z" fill="#fff" />
      <path d="M18.5526 18.986C20.4826 18.8538 21.9999 17.8044 21.9999 16.5294C21.9999 15.2662 20.5088 14.2245 18.6041 14.0767C19.1433 14.744 19.4999 15.5558 19.4999 16.5C19.4999 17.474 19.1205 18.3071 18.5526 18.986Z" fill="#fff" />
    </svg>
  )
}

export const EyeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
)


export const TagIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
    <line x1="7" y1="7" x2="7.01" y2="7" />
  </svg>
)

export const TrashIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M3 6h18" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
  </svg>
)

export const CheckIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="green" strokeWidth="2">
    <polyline points="20 6 9 17 4 12" />
  </svg>
)
export const CloseSvg = ({ width = 14, height = 14, color = 'currentColor' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
      fill={color}
    />
  </svg>
);

export const CheckCircleSvg = ({ width = 20, height = 20, color = 'currentColor' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z"
      fill={color}
    />
  </svg>
);

export const ErrorSvg = ({ width = 20, height = 20, color = 'currentColor' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z"
      fill={color}
    />
  </svg>
);

export const WarningSvg = ({ width = 20, height = 20, color = 'currentColor' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 15C9.45 15 9 14.55 9 14C9 13.45 9.45 13 10 13C10.55 13 11 13.45 11 14C11 14.55 10.55 15 10 15ZM11 11H9V5H11V11Z"
      fill={color}
    />
  </svg>
);

export const InfoSvg = ({ width = 20, height = 20, color = 'currentColor' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V9H11V15ZM11 7H9V5H11V7Z"
      fill={color}
    />
  </svg>
);

export const XIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);


export { EyeoffSvg, ArrowRightIcon, TruckWhiteSvg, HelpIcon, BankIcon, SettingsIcon, MyAccountIcon, DeleteIcon, EditIcon, BellIcon, EyeSvg, CancelSvg, NotificationSvg, EditSvg, JobSvg, LocationSvg, PhoneSvg, EmailSvg, NoteSvg, CamraSvg, PlusSvg, UploadSvg, HeartSvg, LocationGreySvg, ClockSvg, CalenderSvg, UserSvg, EditGraySvg, DeleteSvg, EyeSmallSvg, NoteBlackSvg, CrossSvg, MyProfileSvg, MyjobSvg, UploadjobSvg, LogoutSvg, EyeOffSvg, HomeSvg, SearchSvg, DownSvg, JobGreySvg, CheckSvg, LocationSmallSvg, LikedSvg, JobBlackSvg, DownloadWhiteSvg, UserBlack, SearchnewSvg, ExportSvg, DownloadSvg, SaveSvg, RasedSvg, LikeSvg, WorkSvg, FourboxSvg, EmailgreySvg, FourBoxGreySvg, WalletSvg, LikeGreySvg, GreenarrowSvg, RedarrowSvg, CalendarSvg, EyeSmallblackSvg, BoxSvg, CarriersSvg, GpsSvg, GreyArrowSvg, SettingWhiteSvg, RightArrowSvg, TruckSvg, OceanSvg, AirSvg, RailSvg, DowngreySvg, ProgressCheckSvg, LocationBlackSvg, BoxblackSvg, BuildingSvg, Wallet2Svg, VahicalSvg, ProfileEditSvg, VerifiedSvg, MailSvg, PhoneBlackSvg, GrowthSvg, DeleteRedSvg }
